import { Injectable } from '@angular/core';
import { AlertController, NavController, PopoverController, ModalController, LoadingController } from '@ionic/angular';
import { NavigationExtras, Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { DomSanitizer } from "@angular/platform-browser"
import { AddAssetToSceneComponent } from '../author/add-asset-to-scene/add-asset-to-scene.component'
import { AlertService } from './alert.service';
import { UnsavedSceneService } from './unsaved-scene.service'
import { HttpClient } from '@angular/common/http';
import { Scene } from '../models/Scene';
import { ApiSceneService } from '../api-services/scene.api.service';
import { scenes } from 'aframe';
import { AssetInScene } from '../models/AssetInScene';
import { BaseAsset } from '../models/assets/BaseAsset';
import { SceneAssetRelation } from '../models/scene-asset-relations/SceneAssetRelation';
import { ApiAssetService } from '../api-services/asset.api.service';
import { ApiSceneAssetRelationService } from '../api-services/scene-asset-relation.api.service';
import { ApiVrEventService } from '../api-services/vr-event.api.service';
import { ApiVrEventAssetRelationService } from '../api-services/vr-event-asset-relation.api.service';
import { ApiVrEventSceneRelationService } from '../api-services/vr-event-scene-relation.api.service';
import { VrEvent } from '../models/vr-events/VrEvent';
// import { VrSceneAssetsService } from './vr-scene-assets.service';
import { AssetTypeService } from './asset-type.service';
import { QuestionAsset } from '../models/assets/QuestionAsset';
import { MediaAsset } from '../models/assets/MediaAsset';
import { ApiQuestionResponseService } from '../api-services/question-response.api.service';
import { ApiAssetOnAssetManagementPageService } from '../api-services/asset-on-management-page.api.service';
import { TextAsset } from '../models/assets/TextAsset';
import { Model3DAsset } from '../models/assets/Model3DAsset';
import { HotSpotAsset } from '../models/assets/HotSpotAsset';
import { Model3DSceneAssetRelation } from '../models/scene-asset-relations/model3DSceneAssetRelation';
import { ImageSceneAssetRelation } from '../models/scene-asset-relations/imageSceneAssetRelation';
import { VideoSceneAssetRelation } from '../models/scene-asset-relations/videoSceneAssetRelation';
import { VrEventTypeService } from './vr-event-type.service';
import { DeepCopyService } from './deep-copy.service';
import { ValidationService } from './validation.service';
import { AddEventsModalPage } from '../modals/add-events-modal/add-events-modal.page';
import { AssetEvent } from '../models/vr-events/AssetEvent';
import { AddAssetWithinSceneModalPage } from '../modals/add-asset-within-scene-modal/add-asset-within-scene-modal.page';
import { GetAssetsFromDatabaseService } from './get-assets-from-database.service';
import { CopyService } from './copy.service';
import { API_SETTINGS } from '../api-services/API_SETTINGS';
import { VrEventService } from './vr-event.service';
import { SceneEvent } from '../models/vr-events/SceneEvent';
import { FileService } from './file.service';
import { QuestionSetAsset } from '../models/assets/QuestionSetAsset';
import { EditResponsesPropertiesModalPage } from '../modals/edit-responses-properties-modal/edit-responses-properties-modal.page';
import { AddQuestionRulesModalPage } from '../modals/add-question-rules-modal/add-question-rules-modal.page';
import { AddSceneModalPage } from '../modals/add-scene-modal/add-scene-modal.page';
import { SaveService } from './save.service';
import { InvisibleAsset } from '../models/assets/InvisibleAsset';
import { MessagesService } from './messages.service';
import { OutcomeActionService } from './outcome-action.service';
import { InvisibleSceneAssetRelation } from '../models/scene-asset-relations/InvisibleSceneAssetRelation';
import { TextToSpeechService } from './text-to-speech.service';
import { ProjectsService } from './projects.service';
import { QuestionResponse } from '../models/assets/QuestionResponse';
import { AudioSceneAssetRelation } from '../models/scene-asset-relations/AudioSceneAssetRelation';
import { FontService } from './font.service';
import { AutoSaveService } from './auto-save.service';
import { AssetManagementService } from './asset-management.service';
import { AssetWizardModalPage } from '../modals/asset-wizard-modal/asset-wizard-modal.page';
import { ApiQuestionRuleService } from '../api-services/question-rule.api.service';
import { VrEventAssetRelation } from '../models/vr-events/VrEventAssetRelation';

@Injectable({
  providedIn: 'root'
})
export class AuthorService {

  public isAuthoring = false;
  public skyId;
  public scenes: Scene[] = [];
  public scenesCopy: Scene[] = [];
  public assetsInScene: AssetInScene[] = [];
  public assetsInSceneCopy: AssetInScene[] = [];
  public currentScene: Scene = null;
  public videoBackground: any;
  public videoCurrentTimeString: string = '';
  public videoCurrentTimeInterval = null;
  public movingObject: AssetInScene = null;
  public cameraPos;
  public currentAudio = null;
  public fontFamilyOptions: any = [];
  public isVrEventSettingNewPosition: boolean = false;
  public audios: any[] = [];
  public selectedAsset: AssetInScene = null;
  public selectedAssetId: number;
  public selectedAssetIndex: number = 0;
  public selectAssetLinkedToManagementPage: boolean
  public leftToolbarIndex: number = 0;
  public bottomToolbarIndex: number = 0;
  public backgroundDefault: string = 'assets/DefaultProjectThumbnail.png';
  public videoProgressBar: any;
  public addedSceneAssetRelationIds: number[] = [];
  public assetCardPropertiesCurrentId: number;
  private _isModalOpen: boolean = false;
  public runAutosave: boolean = false;
  public autosaveInterval = null;

  constructor(
    public alertController: AlertController,
    public unsavedSceneService: UnsavedSceneService,
    public alertService: AlertService,
    public navController: NavController,
    private storage: Storage,
    private sanitizer: DomSanitizer,
    public popoverController: PopoverController,
    public http: HttpClient,
    public sceneAPIService: ApiSceneService,
    public assetTypeService: AssetTypeService,
    public assetAPIService: ApiAssetService,
    public sceneAssetRelationAPIService: ApiSceneAssetRelationService,
    public VrEventAPIService: ApiVrEventService,
    public getAssetsFromDatabaseService: GetAssetsFromDatabaseService,
    public VrEventAssetRelationAPIService: ApiVrEventAssetRelationService,
    public VreventSceneRelationAPIService: ApiVrEventSceneRelationService,
    public responseAPIService: ApiQuestionResponseService,
    public VrEventTypeService: VrEventTypeService,
    public assetOnAssetManagementPageAPIService: ApiAssetOnAssetManagementPageService,
    public deepCopyService: DeepCopyService,
    public validationService: ValidationService,
    public modalController: ModalController,
    public loadingController: LoadingController,
    public copyService: CopyService,
    public VrEventService: VrEventService,
    public fileService: FileService,
    public assetManagePageAPIService: ApiAssetOnAssetManagementPageService,
    public assetManagementService: AssetManagementService,
    public saveService: SaveService,
    public messagesService: MessagesService,
    public outcomeActionService: OutcomeActionService,
    public textToSpeechService: TextToSpeechService,
    public questionResponseAPIService: ApiQuestionResponseService,
    public projectService: ProjectsService,
    public router: Router,
    public fontService: FontService,
    public autoSaveService: AutoSaveService,
    public questionRuleAPIService: ApiQuestionRuleService
  ) {
    this.scenes = [];

    // All fonts found in google fonts catalog are published under licenses that allow use on commercial or personal work:
    //  https://developers.google.com/fonts/faq

    this.fontFamilyOptions = this.fontService.fontFamilyOptions;
  }

  setSelectedAsset(selectedAsset: AssetInScene, index) {

    this.selectedAsset = selectedAsset;
    this.selectedAssetIndex = index;
    this.selectedAssetId = selectedAsset.sceneAssetRelation.sceneAssetRelationId;
    if (selectedAsset.baseAsset.baseAssetId) {
      this.assetManagePageAPIService.GetAssetOnAssetManagementPagesWithBaseAssetId(selectedAsset.baseAsset.baseAssetId).subscribe(assetManagementPage => {
        if (assetManagementPage == null) {
          this.selectAssetLinkedToManagementPage = false;
        } else {
          this.selectAssetLinkedToManagementPage = true;
        }
      });
    }
  }

  setSelectedAssetPropertiesId(selectedAsset: AssetInScene) {
    this.assetCardPropertiesCurrentId = selectedAsset.sceneAssetRelation.sceneAssetRelationId;
  }

  getSelectedAssetBorderScale(assetInScene: AssetInScene): string {
    var borderScale: string = "0 0 0";
    if (assetInScene) {
      if (this.getIsAssetInAsset(assetInScene.sceneAssetRelation.sceneAssetRelationId)) {
        assetInScene = this.getParentAssetInScene(assetInScene.sceneAssetRelation.sceneAssetRelationId);
      }
      switch (this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId)) {
        case 'Text':
        case 'Audio':
        case 'HotSpot':
        case 'Image':
        case 'Video':
        case 'Invisible': {
          borderScale = "1 1 0.1"
          break;
        }
        case 'Question':
        case 'QuestionSet':
        case 'Model3D': {
          borderScale = assetInScene.sceneAssetRelation.scale;
          break;
        }
      }
    }
    return borderScale;
  }

  getSelectedAssetBorderSideScale(assetInScene: AssetInScene, side: string): string {
    assetInScene = this.getParentAssetInScene(assetInScene.sceneAssetRelation.sceneAssetRelationId);
    var borderSideScale: string = "0 0 0";
    var xScale: number = 0;
    var yScale: number = 0;
    var zScale: number = 0.1;
    var assetType: string = this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId);

    if (assetType == 'Image' || assetType == 'Video' || assetType == 'Audio' || assetType == 'HotSpot' || assetType == 'Invisible') {
      var mediaSceneAssetRelation: any = assetInScene.sceneAssetRelation;
      var borderSize: number = mediaSceneAssetRelation.borderSize > 0 ? mediaSceneAssetRelation.borderSize / 100 : 0;

      if (side == 'top') {
        xScale = +mediaSceneAssetRelation.xScale + (borderSize * 2);
        yScale = 0.02;
      } else if (side == 'right') {
        xScale = 0.02;
        yScale = +mediaSceneAssetRelation.yScale + (borderSize * 2);
      } else if (side == 'bottom') {
        xScale = +mediaSceneAssetRelation.xScale + (borderSize * 2);
        yScale = 0.02;
      } else if (side == 'left') {
        xScale = 0.02;
        yScale = +mediaSceneAssetRelation.yScale + (borderSize * 2);
      }
    } else if (assetType == 'Question') {
      var textToSpeechSize: number = 0;

      if (assetInScene.sceneAssetRelation.textToSpeechUrl && assetInScene.sceneAssetRelation.textToSpeechUrl != '') {
        textToSpeechSize += 0.20;
      }

      if (side == 'top') {
        xScale = 1.5;
        yScale = 0.02;
      } else if (side == 'right') {
        xScale = 0.02;
        yScale = 2.48 + textToSpeechSize;
      } else if (side == 'bottom') {
        xScale = 1.5;
        yScale = 0.02;
      } else if (side == 'left') {
        xScale = 0.02;
        yScale = 2.48 + textToSpeechSize;
      }
    } else if (assetType == 'QuestionSet') {
      var questionSet: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
      var textToSpeechSize: number = 0;
      var arrowsSize: number = 0;
      var indexesSize: number = 0;

      if (((questionSet.questionIndex == -1 || questionSet.questionIndex == assetInScene.assets.length) && assetInScene.sceneAssetRelation.textToSpeechUrl != null)
        || (questionSet.questionIndex >= 0 && questionSet.questionIndex < assetInScene.assets.length && assetInScene.assets[questionSet.questionIndex].sceneAssetRelation.textToSpeechUrl != null)) {
        textToSpeechSize += 0.20;
      }
      if (questionSet.questionIndex >= 0) {
        indexesSize += (0.23 * (Math.floor((assetInScene.assets.length - 0.5) / 8) + 1));
        arrowsSize += 0.4;
      }
      if (questionSet.submitted == true) {
        indexesSize += 0.23;
      }

      if (side == 'top') {
        xScale = 1.5 + arrowsSize;
        yScale = 0.02;
      } else if (side == 'right') {
        xScale = 0.02;
        yScale = 2.48 + textToSpeechSize + indexesSize;
      } else if (side == 'bottom') {
        xScale = 1.5 + arrowsSize;
        yScale = 0.02;
      } else if (side == 'left') {
        xScale = 0.02;
        yScale = 2.48 + textToSpeechSize + indexesSize;
      }
    }

    borderSideScale = `${xScale} ${yScale} ${zScale}`;
    return borderSideScale;
  }

  getSelectedAssetBorderSidePosition(assetInScene: AssetInScene, side: string): string {
    assetInScene = this.getParentAssetInScene(assetInScene.sceneAssetRelation.sceneAssetRelationId);
    var borderSidePosition: string = "0 0 0";
    var xPos: number = 0;
    var yPos: number = 0;
    var zPos: number = 0.5;
    var assetType: string = this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId);

    if (assetType == 'Image' || assetType == 'Video' || assetType == 'Audio' || assetType == 'HotSpot' || assetType == 'Invisible') {
      var mediaSceneAssetRelation: any = assetInScene.sceneAssetRelation;
      var borderSize: number = mediaSceneAssetRelation.borderSize > 0 ? mediaSceneAssetRelation.borderSize / 100 : 0;

      if (side == 'top') {
        yPos = (+mediaSceneAssetRelation.yScale / 2) + borderSize;
      } else if (side == 'right') {
        xPos = (+mediaSceneAssetRelation.xScale / 2) + borderSize - 0.01;
      } else if (side == 'bottom') {
        yPos = ((+mediaSceneAssetRelation.yScale / 2 + borderSize)) * -1;
      } else if (side == 'left') {
        xPos = ((+mediaSceneAssetRelation.xScale / 2) + borderSize - 0.01) * -1;
      }
    } else if (assetType == 'Question') {
      var textToSpeechSize: number = 0;
      if (assetInScene.sceneAssetRelation.textToSpeechUrl && assetInScene.sceneAssetRelation.textToSpeechUrl != '') {
        textToSpeechSize += 0.20;
      }

      if (side == 'top') {
        yPos = 1.23 + textToSpeechSize;
      } else if (side == 'right') {
        yPos = 0 + (textToSpeechSize / 2);
        xPos = 0.74;
      } else if (side == 'bottom') {
        yPos = -1.23;
      } else if (side == 'left') {
        yPos = 0 + (textToSpeechSize / 2);
        xPos = -0.74;
      }
    } else if (assetType == 'QuestionSet') {
      var questionSet: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
      var textToSpeechSize: number = 0;
      var arrowsSize: number = 0;
      var indexesSize: number = 0;

      if (((questionSet.questionIndex == -1 || questionSet.questionIndex == assetInScene.assets.length) && assetInScene.sceneAssetRelation.textToSpeechUrl != null)
        || (questionSet.questionIndex >= 0 && questionSet.questionIndex < assetInScene.assets.length && assetInScene.assets[questionSet.questionIndex].sceneAssetRelation.textToSpeechUrl != null)) {
        textToSpeechSize += 0.20;
      }
      if (questionSet.questionIndex >= 0) {
        indexesSize += (0.23 * (Math.floor((assetInScene.assets.length - 0.5) / 8) + 1));
        arrowsSize += 0.4;
      }
      if (questionSet.submitted == true) {
        indexesSize += 0.23;
      }

      if (side == 'top') {
        yPos = 1.23 + textToSpeechSize;
      } else if (side == 'right') {
        yPos = 0 + (textToSpeechSize / 2) - (indexesSize / 2);
        xPos = 0.74 + (arrowsSize / 2);
      } else if (side == 'bottom') {
        yPos = -1.23 - indexesSize;
      } else if (side == 'left') {
        yPos = 0 + (textToSpeechSize / 2) - (indexesSize / 2);
        xPos = -0.74 - (arrowsSize / 2);
      }
    }

    borderSidePosition = `${xPos} ${yPos} ${zPos}`;
    return borderSidePosition;
  }

  setLeftToolbar(index) {
    this.leftToolbarIndex = index;
  }

  setBottomToolbar(index) {
    this.bottomToolbarIndex = index;
  }

  getTextBaseAsset() {
    return this.selectedAsset.baseAsset as TextAsset;
  }

  getQuestionBaseAsset(assetInScene: AssetInScene = null) {
    if (assetInScene) {
      return assetInScene.baseAsset as QuestionAsset;
    } else {
      return this.selectedAsset.baseAsset as QuestionAsset;
    }
  }

  getQuestionSetBaseAsset() {
    return this.selectedAsset.baseAsset as QuestionSetAsset;
  }

  getMediaBaseAsset() {
    return this.selectedAsset.baseAsset as MediaAsset;
  }

  getInvisibleBaseAsset() {
    return this.selectedAsset.baseAsset as InvisibleAsset;
  }

  getAssetWithSceneAssetRelationId(sceneAssetRelationId: number): AssetInScene {
    // var assets: AssetInScene[] = authorService.assetsInScene;
    // assets.forEach(element => {
    //   if (element.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId) {
    //     asset = element;
    //   }
    //   element.assets.forEach(assetInElement => {
    //     if (assetInElement.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId) {
    //       asset = assetInElement;
    //     }
    //   });
    // });

    var asset: AssetInScene = null;
    var assetInSceneResult = this.assetsInScene.find((assetInScene) => assetInScene.assets.filter((assetInAsset) => assetInAsset.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId).length >= 1);
    if (assetInSceneResult) {
      asset = assetInSceneResult;
      assetInSceneResult = assetInSceneResult.assets.find((assetInAsset) => assetInAsset.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId);
      if (assetInSceneResult) {
        asset = assetInSceneResult;
      }
    } else {
      asset = this.assetsInScene.find((assetInScene) => assetInScene.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId);
    }
    return asset;
  }

  getAssetInSceneIndex(sceneAssetRelationId: number): number {
    return this.assetsInScene.findIndex(a => a.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId);
  }

  getMediaAssetBorderSideScale(assetInScene: AssetInScene, side: string): string {
    var borderSideScale: string = "0 0 0";
    var mediaSceneAssetRelation: any = assetInScene.sceneAssetRelation;
    var xScale: number = 0;
    var yScale: number = 0;
    var zScale: number = 0.1;
    var borderSize: number = mediaSceneAssetRelation.borderSize > 0 ? mediaSceneAssetRelation.borderSize / 100 : 0;

    if (side == 'top') {
      xScale = +mediaSceneAssetRelation.xScale + (borderSize * 2);
      yScale = borderSize;
    } else if (side == 'right') {
      xScale = borderSize;
      yScale = +mediaSceneAssetRelation.yScale;
    } else if (side == 'bottom') {
      xScale = +mediaSceneAssetRelation.xScale + (borderSize * 2);
      yScale = borderSize;
    } else if (side == 'left') {
      xScale = borderSize;
      yScale = +mediaSceneAssetRelation.yScale;
    }

    borderSideScale = `${xScale} ${yScale} ${zScale}`;

    return borderSideScale;
  }

  getMediaAssetBorderSidePosition(assetInScene: AssetInScene, side: string) {
    var borderSidePosition: string = "0 0 0";
    var mediaSceneAssetRelation: any = assetInScene.sceneAssetRelation;
    var xPos: number = 0;
    var yPos: number = 0;
    var zPos: number = 0;
    var borderSize: number = mediaSceneAssetRelation.borderSize > 0 ? mediaSceneAssetRelation.borderSize / 100 : 0.01;

    if (side == 'top') {
      yPos = (+mediaSceneAssetRelation.yScale / 2) + (borderSize / 2);
    } else if (side == 'right') {
      xPos = (+mediaSceneAssetRelation.xScale / 2) + (borderSize / 2);
    } else if (side == 'bottom') {
      yPos = ((+mediaSceneAssetRelation.yScale / 2) + (borderSize / 2)) * -1;
    } else if (side == 'left') {
      xPos = ((+mediaSceneAssetRelation.xScale / 2) + (borderSize / 2)) * -1;
    }

    borderSidePosition = `${xPos} ${yPos} ${zPos}`;

    return borderSidePosition;
  }

  get3dModelSceneAssetRelation() {
    return this.selectedAsset.sceneAssetRelation as Model3DSceneAssetRelation;
  }

  getInvisibleSceneAssetRelation() {
    return this.selectedAsset.sceneAssetRelation as InvisibleSceneAssetRelation;
  }

  removeTextToSpeech(sceneAssetRelation: SceneAssetRelation) {
    sceneAssetRelation.textToSpeechUrl = null;
  }

  //#region DATABASE CALLS

  async addSceneToDb(sceneForDb) {
    await this.messagesService.presentLoadingWindow('Creating scene, please wait.');
    this.sceneAPIService.addScene(sceneForDb).subscribe(scene => {
      this.scenes.push(scene);
      this.scenesCopy = this.deepCopyService.deepCopy(this.scenes);
      this.getSceneEvents(scene);
      this.getSceneOutcomeEvents(scene);
      this.messagesService.loadingWindow.dismiss();
    });
  }

  updateSceneInDb(sceneForDb) {
    this.sceneAPIService.updateScene(sceneForDb.sceneId, sceneForDb).subscribe(res => {
      if (res) {
        this.scenes.forEach(element => {
          if (element.sceneId == res.sceneId) {
            element.name = res.name;
            element.description = res.description;
            element.opened = res.opened;
          }
        });
      }
    })
  }

  getScenes(): Scene[] {
    return this.scenes.filter(s => s.active == true);
  }

  getScenesFromDbWithProjectId(projectId): Promise<void> {
    return new Promise((resolve, reject) => {
      this.sceneAPIService.getScenesWithProjectId(projectId).subscribe(scenes => {
        scenes.sort((a, b) => a.sceneIndex > b.sceneIndex ? 1 : -1).forEach((scene, index) => {
          scene.sceneIndex = index;
        });
        this.scenes = scenes as any;
        this.getScenesEvents().then(() => {
          this.getScenesOutcomeEvents().then(() => {
            this.scenesCopy = this.deepCopyService.deepCopy(this.scenes);
          })

        });
        this.getAssetsInProjectFromDb().then(result => {
          resolve();
        });
      });
    })
  }
  getScenesEvents(): Promise<void> {
    var i: number = 0;
    return new Promise((resolve) => {
      this.scenes.forEach(async scene => {
        await this.getSceneEvents(scene);
        i++;
        if (i == this.scenes.length) {
          resolve();
        }
      });
      if (this.scenes.length == 0) {
        resolve();
      }
    });
  }

  getScenesOutcomeEvents() {
    var i: number = 0;
    return new Promise((resolve) => {
      this.scenes.forEach(async scene => {
        await this.getSceneOutcomeEvents(scene);
        i++;
        if (i == this.scenes.length) {
          resolve();
        }
      });
      if (this.scenes.length == 0) {
        resolve();
      }
    });
  }

  getSceneOutcomeEvents(scene: Scene) {
    return new Promise((resolve) => {
      scene.outcomeActions = [];
      this.outcomeActionService.getOutcomeActionBySceneId(scene.sceneId).then(x => {
        if (x.length == 0) {
          resolve();
        } else {
          scene.outcomeActions = this.deepCopyService.deepCopy(x);
        }
      });
    });
  }

  getSceneEvents(scene): Promise<void> {
    var i: number = 0;
    return new Promise((resolve) => {
      scene.events = [];
      this.VreventSceneRelationAPIService.getVrEventSceneRelationsWithSceneId(scene.sceneId).subscribe(VrEventSceneRelations => {
        VrEventSceneRelations.forEach((VrEventSceneRelation) => {
          this.VrEventAPIService.getVrEvent(VrEventSceneRelation.vrEventId).subscribe(VrEvent => {
            var eventForScene: SceneEvent = VrEvent as SceneEvent;
            eventForScene.sceneId = VrEventSceneRelation.sceneId;
            scene.events.push(eventForScene);

            i++;
            if (i == VrEventSceneRelations.length) {
              resolve();
            }
          });
        });
        if (VrEventSceneRelations.length == 0) {
          resolve();
        }
      });
    });
  }

  updateScale(assetInScene: AssetInScene) {
    var assetType = this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId);
    var x = assetInScene.sceneAssetRelation.xScale;
    var y = assetInScene.sceneAssetRelation.yScale;
    var z = assetInScene.sceneAssetRelation.zScale;

    if (assetInScene.sceneAssetRelation.scale != x + " " + y + " " + z) {
      // text/hotspot/question/questionSet uses X for both X and Y axis, with Z always 0.1. 
      if (assetType === 'Text' || assetType == 'HotSpot' || assetType == 'Question' || assetType == 'QuestionSet') {
        if (assetInScene.sceneAssetRelation.scale != x + " " + y + " 0.1") {
          assetInScene.sceneAssetRelation.yScale = x;
          y = x;
        }
      }

      assetInScene.sceneAssetRelation.scale = x + " " + y + " " + z;
    }
  }

  updateMediaAssetScale(assetInScene: AssetInScene) {
    let mediaAsset = assetInScene.baseAsset as MediaAsset;
    let mediaSceneAssetRelation = assetInScene.sceneAssetRelation as ImageSceneAssetRelation;

    if (mediaSceneAssetRelation.keepAspectRatio === true) {
      let xScale: number = Number(mediaSceneAssetRelation.xScale);
      let yScale: number = xScale * mediaSceneAssetRelation.aspectRatioConstant;
      mediaSceneAssetRelation.yScale = String(yScale);
    }
    this.updateScale(assetInScene);
  }

  updatePosition(assetInScene: AssetInScene) {
    if (assetInScene.sceneAssetRelation && assetInScene.sceneAssetRelation.position != assetInScene.sceneAssetRelation.xPos + " " + assetInScene.sceneAssetRelation.yPos + " " + assetInScene.sceneAssetRelation.zPos) {
      assetInScene.sceneAssetRelation.position = assetInScene.sceneAssetRelation.xPos + " " + assetInScene.sceneAssetRelation.yPos + " " + assetInScene.sceneAssetRelation.zPos;
    }
  }

  updateRotation(sceneAssetRelation: Model3DSceneAssetRelation) {
    var x = sceneAssetRelation.xRot ? sceneAssetRelation.xRot : '0';
    var y = sceneAssetRelation.yRot ? sceneAssetRelation.yRot : '0';
    var z = sceneAssetRelation.zRot ? sceneAssetRelation.zRot : '0';

    if (sceneAssetRelation.rotation != x + " " + y + " " + z || !sceneAssetRelation.rotation) {
      sceneAssetRelation.rotation = x + " " + y + " " + z;
    }
  }

  getAssetsInProjectFromDb(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      var sceneIds: number[] = this.getIds(this.scenes, 'sceneId');
      this.getAssetsFromDatabaseService.getAssetsWithSceneIds(sceneIds).then(assetsInScenes => {
        this.assetsInScene = assetsInScenes;        
        this.assetsInSceneCopy = this.deepCopyService.deepCopy(assetsInScenes);
        this.setVideosToCheckUploadStatus();
        this.fileService.initialiseVideoUploadStatusCheck();
        this.orderAssetsByAssetType();
        resolve(true);
      });
    });
  }

  getAssetsInScenesFromDb(sceneId) {
    return this.getAssetsFromDatabaseService.getAssetsWithSceneIds(sceneId);
  }

  getAssetInSceneFromDb(sceneId, assetSceneAssetRelationId) {
    return this.getAssetsFromDatabaseService.getAssetsWithSceneIds(sceneId).then(sceneAssets => {
      return sceneAssets.find(x => x.sceneAssetRelation.sceneAssetRelationId == assetSceneAssetRelationId);
    });
  }

  setUpSceneAssetRelationParameters(relation, assetType) {
    switch (assetType) {
      case 'Text': {
        this.setUpAssetScale(relation, relation.xScale, relation.xScale, relation.zScale);
        break;
      }
      default: {
        this.setUpAssetScale(relation, relation.xScale, relation.yScale, relation.zScale);
        break;
      }
    }
    this.setUpAssetPosition(relation, relation.xPos, relation.yPos, relation.zPos);
  }
  //#endregion

  clearScene() {
    this.clearArray(this.scenes);
    this.currentScene = new Scene();
  }

  clearArray(elements) {
    while (elements.length > 0) {
      elements.pop();
    }
  }

  clearProjectContents() {

    this.clearArray(this.scenes);
    // this.clearArray(this.sceneBackgrounds);
    this.assetsInScene.forEach(assetInScene => {
      this.clearArray(assetInScene.events)
    });

    this.clearArray(this.assetsInScene);
    this.clearArray(this.addedSceneAssetRelationIds);

    this.clearScene();
  }

  async resetScene(scene) {
    await this.messagesService.presentLoadingWindow('Resetting Scene: ' + scene.name);
    if (this.currentScene.sceneBackgroundFileType == 'Video') {
      this.resetVideo();
    }
    this.movingObject = null;
    this.selectedAsset = null;
    var index = this.scenes.indexOf(scene);
    var sceneToCopy = this.scenesCopy.find(x => x.sceneId == scene.sceneId);
    var actualSceneIndex = this.scenes[index].sceneIndex;
    this.scenes[index] = this.deepCopyService.deepCopy(sceneToCopy);
    this.scenes[index].sceneIndex = actualSceneIndex;
    this.currentScene = this.scenes[index];
    this.resetAssetsInScene(scene.sceneId);
  }

  resetAssetsInScene(sceneId: number) {
    //remove all the current assets in the scene that have the scene id thats being reset
    this.assetsInScene.filter(a => a.sceneAssetRelation.sceneId == sceneId).forEach((assetInScene) => {
      let index = this.assetsInScene.indexOf(assetInScene);
      this.assetsInScene.splice(index, 1);
      index = this.addedSceneAssetRelationIds.indexOf(assetInScene.sceneAssetRelation.sceneAssetRelationId);
      this.addedSceneAssetRelationIds.splice(index, 1);
    });
    //push the assets from the database back onto the assets in the scene
    this.getAssetsInScenesFromDb([sceneId]).then(sceneAssets => {
      sceneAssets.forEach(asset => {
        this.addAssetToServices(asset);
      });
      this.messagesService.loadingWindow.dismiss();
    });
  }

  async resetAssetInScene(sceneId, assetInScene: AssetInScene) {
    await this.messagesService.presentLoadingWindow('Resetting Media: ' + assetInScene.baseAsset.name);
    if (this.currentScene.sceneBackgroundFileType == 'Video') {
      this.resetVideo();
    }
    var currentAssetIndex = this.assetsInScene.findIndex(x => x.sceneAssetRelation.sceneAssetRelationId == assetInScene.sceneAssetRelation.sceneAssetRelationId);

    if (currentAssetIndex != -1) {
      this.getAssetInSceneFromDb([sceneId], assetInScene.sceneAssetRelation.sceneAssetRelationId).then(assetInDb => {
        if (assetInDb) {
          this.assetsInScene[currentAssetIndex] = this.deepCopyService.deepCopy(assetInDb);
          this.messagesService.loadingWindow.dismiss();
        }
        else {
          this.messagesService.loadingWindow.dismiss();
        }
      });
    }
    else {
      this.messagesService.loadingWindow.dismiss();
    }
  }

  validateAndResetBaseAssetProperty(baseAsset: any, prop: string) {
    var value = "";
    eval("value = baseAsset." + prop);
    if (this.validationService.isEmptyOrNull(value)) {
      this.resetBaseAssetProperty(baseAsset, prop);
    }
  }

  resetBaseAssetProperty(baseAsset: any, prop: string) {
    var assetInSceneCopy: any = this.assetsInSceneCopy.find(a => a.baseAsset.baseAssetId == baseAsset.baseAssetId);
    if (assetInSceneCopy) {
      eval("baseAsset." + prop + " = assetInSceneCopy.baseAsset." + prop);
    } else {
      eval("baseAsset." + prop + " = 'Default'");
    }
  }

  breakConnectionWithAssetsManagementPage(asset: any): AssetInScene {
    var name = asset.baseAsset.name;
    var newAsset = this.copyAssetInScene(asset);
    this.setAssetToBeRemoved(asset);
    newAsset.baseAsset.name = name;

    return newAsset;
  }


  async presentUpsertScene(scene, projectId) {
    var isEditing: boolean = scene == null ? false : true;
    var oldSceneName = isEditing ? scene.name : '';
    var oldSceneDesc = isEditing ? scene.description : '';

    if (this._isModalOpen === true) return;
    this._isModalOpen = true;

    const addOrEditSceneModal = await this.modalController.create({
      id: 'add-scene-modal',
      component: AddSceneModalPage,
      componentProps: {
        "isEditing": isEditing,
        "scene": scene == null ? new Scene() : scene,
      }
    });

    addOrEditSceneModal.onDidDismiss().then(async result => {
      if (result.data) {

        var sceneForDb: Scene = this.populateScene(result.data, scene, projectId);
        if (this.scenes.length > 0) {
          sceneForDb.sceneIndex = Math.max.apply(Math, this.scenes.map(function (a) { return a.sceneIndex; })) + 1;
        }

        if (!this.validationService.isEmptyOrNull(sceneForDb.name)) {
          if (scene == null) {
            sceneForDb.name = this.validationService.removeHtmlTags(sceneForDb.name);
            this.addSceneToDb(sceneForDb);
            this.messagesService.savedSuccessfully('New Scene');
          } else {
            this.scenes.forEach(x => {
              if (x.sceneId == sceneForDb.sceneId) {
                x.name = this.validationService.removeHtmlTags(sceneForDb.name);
                x.description = sceneForDb.description;
                this.updateSceneInDb(x);
                this.messagesService.updatedSuccessfully('Scene');
              }
            });
          }
        } else {
          this.alertForSceneName();
        }
      } else if (isEditing) {
        var data: Scene = this.scenes.filter(p => p.sceneId == scene.sceneId)[0];
        data.name = oldSceneName;
        data.description = oldSceneDesc;
      }
      this._isModalOpen = false;
    });

    return await addOrEditSceneModal.present();

  }

  async alertForSceneName() {
    const alert = await this.alertController.create({
      header: 'Scene Name Required',
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }

  populateScene(userInput, scene, projectId) {
    var sceneForDb: Scene = new Scene();
    sceneForDb.sceneId = scene != null ? scene.sceneId : 0,
      sceneForDb.name = userInput.name;
    sceneForDb.description = userInput.description;
    sceneForDb.active = true;
    sceneForDb.projectId = projectId;
    sceneForDb.sceneBackgroundColour = '#dddddd';
    sceneForDb.sceneBackgroundFileType = '';
    sceneForDb.sceneBackgroundSrc = '';
    sceneForDb.events = [];
    sceneForDb.opened = false;
    return sceneForDb;
  }

  setMaxLengths() {
    document.getElementById('maxLength30').setAttribute('maxlength', '30');
    document.getElementById('maxLength100').setAttribute('maxlength', '100');
  }

  launchScene(sceneId: number) {
    this.currentScene = null;
    this.runAutosave = false;
    this.stopAllMedia();
    this.scenes.forEach(async scene => {
      if (scene.sceneId == sceneId) {
        await this.messagesService.presentLoadingWindow("Launching scene, please wait...").then(x => {
          this.currentScene = scene;
          if (this.currentScene.sceneBackgroundFileType == 'Image') {
            this.skyId = '#pano-' + scene.sceneId + '-Image';
          } else if (this.currentScene.sceneBackgroundFileType == 'Video') {
            this.skyId = '#pano-' + scene.sceneId + '-Video';
            if (this.videoBackground) {
              this.setVideoBackground();
            }
          } else {
            this.skyId = scene.sceneBackgroundFileType == '' ? null : '#pano-' + scene.sceneId;
          }

          var background = document.querySelector(this.skyId);
          var loadingAttr = null;
          if (background) {
            var loadingAttr = background.getAttribute('loading');
          }
          if (!loadingAttr) {
            this.messagesService.loadingWindow.dismiss();
          }

          if (!this.currentScene.opened) {
            scene.wireframe = true;
            scene.opened = true;
            this.updateSceneInDb(this.currentScene);
            document.getElementById('scene-card-settings-container-' + scene.sceneId).click();
          }
          else {
            scene.wireframe = false;
          }
        });
        this.runAutosave = true;
        await this.startAutosave(90000);
      }
    });
  }

  startAutosave(interval: number) {
    this.autosaveInterval = setTimeout(async () => {
      if (this.runAutosave) {
        if (!this.autoSaveService.saving && this.movingObject == null) {
          this.runAutosave = false;
          this.autoSaveService.saving = true;
          await new Promise<void>((resolve) => {
            this.saveService.saveProject(this.projectService.project, this.scenes, this.assetsInScene).then(async project => {
              let fileStorageUsagePercentage: number = await this.projectService.customerUsageService.getFileStorageCreditsUsagePercentage();

              if (fileStorageUsagePercentage >= 100) {
                await this.messagesService.loadingWindow.dismiss();
                this.messagesService.savedSuccessfully('Project');
                let alertResult = await this.goToAccountPageAlert();
                resolve();
                return;
              }

              this.getScenesEvents().then(() => {
                this.scenesCopy = this.deepCopyService.deepCopy(this.scenes);
                this.assetsInSceneCopy = this.deepCopyService.deepCopy(this.assetsInScene);
                //this.messagesService.loadingWindow.dismiss();
                this.autoSaveService.saving = false;
                this.runAutosave = true;
                resolve();
              });
              this.removeDeletedAssetsInScene();
            });
          });
          this.startAutosave(90000);
        } else {
          this.startAutosave(5000);
        }
      }
    }, interval);
  }

  stopAutoSave(){
    clearInterval(this.autosaveInterval);
    this.autosaveInterval = null;    
  }

  setVideoBackground() {
    this.videoBackground = document.querySelector('#pano-' + this.currentScene.sceneId + '-Video');
    this.videoProgressBar = document.querySelector('#video-progress');
    if (this.videoBackground) {
      this.videoCurrentTimeString = this.formatCurrentTime(this.videoBackground.currentTime, this.videoBackground.duration);
    }
  }

  stopAllMedia() {
    var media = document.querySelectorAll('video, audio');
    media.forEach((mediaElement: any) => {
      this.stopMedia(mediaElement);
    });
  }

  stopMedia(mediaElement: any) {
    mediaElement.pause();
    mediaElement.currentTime = 0;
  }

  getIds(array, param): number[] {
    var ids: number[] = [];
    array.forEach(element => {
      ids.push(element[param]);
    })
    return ids;
  }

  initialiseVideoBar() {
    this.videoProgressBar = document.querySelector('#video-progress');
    /* this.videoBackground.addEventListener('timeupdate', (event) => {
      if (this.videoProgressBar) {
        this.videoProgressBar.setAttribute('value', event.target.currentTime);
      }
    }); */
    this.videoCurrentTimeInterval = setInterval(() => {
      this.videoProgressBar.setAttribute('value', + this.videoBackground.currentTime);
      this.videoCurrentTimeString = this.formatCurrentTime(this.videoBackground.currentTime, this.videoBackground.duration);
    }, 10);
  }

  removeVideoBarInterval() {
    /* this.videoBackground.addEventListener('timeupdate', (event) => {
      if (this.videoProgressBar) {
        this.videoProgressBar.setAttribute('value', event.target.currentTime);
      }
    }); */
    if (this.videoCurrentTimeInterval) {
      window.clearInterval(this.videoCurrentTimeInterval);
      this.videoCurrentTimeInterval = null;
    }
  }

  formatCurrentTime(seconds: number, duration: number): string {

    var hoursDuration = duration / 60 / 60;
    var hours = Math.floor(seconds / 60 / 60);
    var hoursStr = (hours >= 10) ? (hours) : "0" + (hours);
    var minutes = Math.floor(seconds / 60);
    var minutesStr = (minutes >= 10) ? (minutes) : "0" + (minutes);
    seconds = Math.floor(seconds % 60);
    var secondsStr = (seconds >= 10) ? (seconds) : "0" + (seconds);
    if (hoursDuration >= 1) {
      return hours + ":" + minutesStr + ":" + secondsStr;
    } else {
      return minutesStr + ":" + secondsStr;
    }
  }

  pauseVideo() {
    if (this.videoBackground.paused != true) {
      this.removeVideoBarInterval();
      this.videoBackground.pause();
    }
  }

  setVideoCurrentTime(event) {
    if (this.videoBackground.paused == true) {
      this.videoBackground.currentTime = String(+event.target.value);
      // console.log("set current time" + this.videoBackground.currentTime);
    }
    this.videoCurrentTimeString = this.formatCurrentTime(event.target.value, this.videoBackground.duration);
  }

  playOrPauseVideo() {
    // console.log("before pause/play" + this.videoBackground.currentTime);
    if (this.videoBackground.paused == true) {
      this.initialiseVideoBar();
      // console.log("play" + this.videoBackground.currentTime);
      this.videoBackground.play();
    } else {
      this.removeVideoBarInterval();
      // console.log("pause" + this.videoBackground.currentTime);
      this.videoBackground.pause();
    }
  }

  resetVideo() {
    this.videoBackground.pause();
    this.videoBackground.currentTime = 0;
    this.videoProgressBar.setAttribute('value', + this.videoBackground.currentTime);
  }

  getBaseAssetIdsFromSceneAssetRelations(sceneAssetRelations: SceneAssetRelation[]): number[] {
    var baseAssetIds: number[] = [];
    sceneAssetRelations.forEach(relation => {
      baseAssetIds.push(relation.baseAssetId);
    })
    return baseAssetIds;
  }

  addQuestionToAsset(assetInScene: AssetInScene) {
    var question: QuestionAsset = new QuestionAsset();
    question.assetTypeId = this.assetTypeService.getId('Question') as number;
    question.name = "Default Question"
    question.text = "Default Question"
    question.planeColour = '#ffffff';
    question.textColour = '#000000';
    question.fontFamily = "../assets/fonts/opensans/OpenSans-Regular-msdf.json";
    question.backgroundOpacity = 1;
    question.textSize = 30;
    question.correctMessage = "Well Done!";
    question.incorrectMessage = "You got this wrong!";
    question.score = 1;
    question.responses = [];
    var assetForAsset: AssetInScene = this.addSceneAssetRelation(question);
    assetForAsset.sceneAssetRelation.sceneAssetRelationId = assetForAsset.sceneAssetRelation.sceneAssetRelationId + assetInScene.assets.length + 1;
    assetForAsset.assets = [];
    assetForAsset.questionRules = [];
    assetInScene.assets.push(assetForAsset);

    this.addResponseToQuestion(question, 1);
    this.addResponseToQuestion(question, 2);
  }

  addResponseToQuestion(baseAsset: QuestionAsset, i: number = 0) {
    var response: QuestionResponse = new QuestionResponse();
    let imageAssetForScene: AssetInScene;
    let videoAssetForScene: AssetInScene;
    let audioAssetForScene: AssetInScene;
    response.isCorrect = i == 1 ? true : false;
    response.text = 'Default Response ' + (i >= 1 ? i : '');
    response.textSize = 30;
    response.hasImage = false;
    response.hasVideo = false;
    response.hasAudio = false;
    response.hasLinkedScene = false;
    response.linkedSceneID = 0;
    response.questionResponseIndex = baseAsset.responses.length;
    response.fontFamily = "../assets/fonts/opensans/OpenSans-Regular-msdf.json";
    response.assets = [];

    imageAssetForScene = this.addQuestionResponseMediaAsset(response, 'Image', 0);
    videoAssetForScene = this.addQuestionResponseMediaAsset(response, 'Video', 1);
    audioAssetForScene = this.addQuestionResponseMediaAsset(response, 'Audio', 2);

    response.imageSceneAssetRelationId = imageAssetForScene.sceneAssetRelation.sceneAssetRelationId;
    response.videoSceneAssetRelationId = videoAssetForScene.sceneAssetRelation.sceneAssetRelationId;
    response.audioSceneAssetRelationId = audioAssetForScene.sceneAssetRelation.sceneAssetRelationId;
    response.assets.push(imageAssetForScene);
    response.assets.push(videoAssetForScene);
    response.assets.push(audioAssetForScene);

    baseAsset.responses.push(response);
  }

  addAssetToServices(asset: AssetInScene, copyScene: boolean = false) {
    var sceneAssetRelationIds: number[] = [];

    this.selectedAsset = null;

    this.assetsInScene.forEach(asset => {
      sceneAssetRelationIds.push(asset.sceneAssetRelation.sceneAssetRelationId);
    });


    if (!sceneAssetRelationIds.includes(asset.sceneAssetRelation.sceneAssetRelationId)) {
      this.assetsInScene.push(asset);
      if (copyScene == false)
        this.addedSceneAssetRelationIds.push(asset.sceneAssetRelation.sceneAssetRelationId);
      
      this.orderAssetsByAssetType();
    }
  }

  async deleteScene(scene: Scene) {
    const alert = await this.alertController.create({
      header: 'Please confirm',
      message: "are you sure you want to delete the scene '" + scene.name + "'?",
      buttons: [{
        text: 'Cancel',
      }, {
        text: 'Delete',
        handler: () => {
          this.scenes.forEach(sceneElement => {
            if (sceneElement.sceneId == scene.sceneId) {
              if (this.currentScene.sceneId == scene.sceneId) {
                this.currentScene = null;
              }

              sceneElement.active = false;
              this.saveService.updateSceneToDb(sceneElement);
              // this.unsavedSceneService.setHasSceneBeenSaved(true);
            }
          })
          var scenesToOrder = this.scenes.filter(s => s.sceneIndex > scene.sceneIndex);
          scenesToOrder.forEach(sceneToOrder => {
            sceneToOrder.sceneIndex--;
          });
        }
      }]
    });
    await alert.present();
  }

  deleteAssetInScene(assetInScene: AssetInScene) {
    var mediaElement = document.querySelector('#asset-' + this.selectedAsset.sceneAssetRelation.sceneAssetRelationId);

    var mediaType = this.assetTypeService.getType(this.selectedAsset.baseAsset.assetTypeId);
    if (mediaType == "Video" || mediaType == "Audio") {
      this.stopMedia(mediaElement);
    }

    this.confirmAssetRemovalFromScene(assetInScene);
  }

  async confirmAssetRemovalFromScene(assetInScene: AssetInScene) {
    const alert = await this.alertController.create({
      header: 'Please confirm',
      message: "Confirm deletion of media '" + assetInScene.baseAsset.name + "'?",
      buttons: [{
        text: 'Cancel',
      }, {
        text: 'Delete',
        handler: () => {
          this.setAssetToBeRemoved(assetInScene);
        }
      }
      ]
    });
    await alert.present();
  }

  setAssetToBeRemoved(assetInScene: AssetInScene) {
    if (this.movingObject && this.movingObject.sceneAssetRelation.sceneAssetRelationId == assetInScene.sceneAssetRelation.sceneAssetRelationId) {
      this.movingObject = null;
    }

    if (this.selectedAsset && this.selectedAsset.baseAsset.baseAssetId == assetInScene.baseAsset.baseAssetId) {
      this.selectedAsset = null;
    }

    // this.vrSceneAssetsService.assets.filter(a => a.sceneAssetRelation.sceneAssetRelationId == assetInScene.sceneAssetRelation.sceneAssetRelationId)[0].toBeRemoved = true;
    this.assetsInScene.filter(a => a.sceneAssetRelation.sceneAssetRelationId == assetInScene.sceneAssetRelation.sceneAssetRelationId)[0].toBeRemoved = true;
    this.removeAssetFromVideosToCheckUploadStatus(assetInScene);
    // this.vrSceneAssetsService.assets = this.assetsInScene;
    this.unsavedSceneService.setHasSceneBeenSaved(true);
  }

  moveObject(assetInScene: AssetInScene) {
    this.movingObject = assetInScene;
  }

  getCameraRot() {
    try {
      var camera = document.querySelector("[camera]") as any;
      return camera.getAttribute("rotation");
    } catch {
      return null;
    }
  }

  getPos() {
    let rotation = this.getCameraRot();

    var distance = 2;

    var rotX = 270;
    var rotY = 90;
    if (rotation) {
      rotX = 270 + -rotation.y; // 270 (0 - 359)
      rotY = 90 + -rotation.x; // 90 (0 - 180)
    }

    var s = rotX;
    var t = rotY;
    var r = distance;

    var theta = ((2 * Math.PI) / 360) * s;
    var phi = (Math.PI / 180) * t;

    var x = Math.cos(theta) * Math.sin(phi) * r;
    var z = Math.sin(theta) * Math.sin(phi) * r;
    var y = Math.cos(phi) * r;

    var pos = {
      "x": x,
      "y": y,
      "z": z
    };

    return pos;
  }

  moveCameraToAssetPosition(x, y, z) {

    let camera = document.querySelector('[camera]');
    var distance = 2;

    var phi = Math.acos(y / distance);
    var theta = Math.asin(z / (Math.sin(phi) * distance));

    var rotX = theta * 180 / Math.PI;
    var rotY = phi * 180 / Math.PI;

    var oldXRot = rotX;

    rotX = 90 - rotY;

    if (x > 0) {
      rotY = 360 - oldXRot - 90;
    } else {
      rotY = oldXRot + 90;
    }

    camera.components["look-controls"].pitchObject.rotation.x = rotX * 1.5708 / 90  // vertical
    camera.components["look-controls"].yawObject.rotation.y = rotY * 6.2831 / 360   // horizontal
  }

  addAudio() {
    this.audios.push({
      "name": 'Default Audio',
      "text": "",
      "url": "",
      "expanded": false,
      "sceneId": this.currentScene.sceneId,
    });
  }

  playAudio(audio) {
    this.currentAudio = audio;
  }

  async deleteAudio(i) {
    const alert = await this.alertController.create({
      header: 'Please confirm',
      message: "Confirm deletion of audio '" + this.audios[i].name + "'?",
      buttons: [{
        text: 'Cancel',
      }, {
        text: 'Delete',
        handler: () => {
          //this.audios.splice(index, 1);
          this.unsavedSceneService.setHasSceneBeenSaved(true);
        }
      }
      ]
    });
    await alert.present();
  }

  generateAudio(audio) {
    audio.url = API_SETTINGS.API_URL + "audio/" + prompt("Enter your desired audio text here");
  }

  async addObjectSelector() {

    if (this.movingObject != null) {
      this.movingObject.sceneAssetRelation.xPos = this.cameraPos.x.toString();
      this.movingObject.sceneAssetRelation.yPos = this.cameraPos.y.toString();
      this.movingObject.sceneAssetRelation.zPos = this.cameraPos.z.toString();
      this.movingObject.sceneAssetRelation.position = this.cameraPos.x + " " + this.cameraPos.y + " " + this.cameraPos.z;
      this.movingObject = null;
      return;
    }

    let questionSetAsset = new QuestionSetAsset();
    let questionAsset = new QuestionAsset();
    questionSetAsset.assetTypeId = this.assetTypeService.getId('QuestionSet');
    questionAsset.assetTypeId = this.assetTypeService.getId('Question');
    let questionSetAssetInScene = this.addSceneAssetRelation(questionSetAsset);
    let questionAssetInScene = this.addSceneAssetRelation(questionAsset);

    const popover = await this.popoverController.create({
      component: AddAssetToSceneComponent,
      componentProps: {
        position: this.cameraPos,
        pop: this.popoverController,
        existingAssetsInScene: this.assetsInScene.filter(a => a.sceneAssetRelation.sceneId == this.currentScene.sceneId), //.filter(a => a.toBeRemoved == false),
        existingScenes: this.scenes, //.filter(s => s.active == true),
        questionSetAssetInScene: questionSetAssetInScene,
        questionAssetInScene: questionAssetInScene
      },
      translucent: true
    });

    popover.onDidDismiss().then(async result => {
      let assetForScene: AssetInScene;
      if (result && result.data && result.data.asset) {
        if (result.data.asset.assetManagementPageId >= 0) {
          this.assetAPIService.getBaseAsset(result.data.asset.assetManagementPageId).subscribe(assetFromDb => {
            assetForScene = this.addSceneAssetRelation(assetFromDb);
            assetForScene.baseAsset.name = assetForScene.baseAsset.name.substr(0, 40);
            assetForScene.assets = [];
            assetForScene.questionRules = [];
            assetForScene.outcomeActions = [];

            if (result.data.assetType == 'Video') {
              let videoSceneAssetRelation = assetForScene.sceneAssetRelation as VideoSceneAssetRelation;
              videoSceneAssetRelation.keepAspectRatio = true;
              videoSceneAssetRelation.aspectRatioConstant = result.data.aspectRatioConstant;
            } else if (result.data.assetType == 'Image') {
              let imageSceneAssetRelation = assetForScene.sceneAssetRelation as ImageSceneAssetRelation;
              imageSceneAssetRelation.keepAspectRatio = true;
              imageSceneAssetRelation.aspectRatioConstant = result.data.aspectRatioConstant;
            }
            this.addAssetToServices(assetForScene);
          });
        } else if (result.data.assetType == 'QuestionSet') {
          await this.addQuestionSetToServices(result.data);
        } else if (result.data.assetType == 'Question') {
          await this.addQuestionToServices(result.data);
        } else {
          assetForScene = this.addSceneAssetRelation(result.data.asset);
          assetForScene.baseAsset.name = assetForScene.baseAsset.name.substr(0, 40);
          assetForScene.assets = [];
          assetForScene.questionRules = [];
          assetForScene.outcomeActions = [];
          this.addAssetToServices(assetForScene);

          if (result.data.assetType == 'Video') {
            let videoSceneAssetRelation = assetForScene.sceneAssetRelation as VideoSceneAssetRelation;
            let videoAsset = assetForScene.baseAsset as MediaAsset;
            videoSceneAssetRelation.keepAspectRatio = true;
            videoSceneAssetRelation.aspectRatioConstant = result.data.aspectRatioConstant;
            videoAsset.uploadStatus = 'uploading';
            videoAsset.src = this.fileService.videoAssetUploadingPlaceholder;
            this.fileService.addVideoToCheckUploadStatus('baseAsset', assetForScene.sceneAssetRelation.sceneAssetRelationId, videoAsset, result.data.assetSrc);
            this.fileService.initialiseVideoUploadStatusCheck();
          } else if (result.data.assetType == 'Image') {
            let imageSceneAssetRelation = assetForScene.sceneAssetRelation as ImageSceneAssetRelation;
            imageSceneAssetRelation.keepAspectRatio = true;
            imageSceneAssetRelation.aspectRatioConstant = result.data.aspectRatioConstant;
            assetForScene.baseAsset['src'] = result.data.assetSrc;
          } else if (this.validationService.isMediaAsset(result.data.assetType)) {
            assetForScene.baseAsset['src'] = result.data.assetSrc;
          } else if (result.data.assetType == 'Question') {

            let questionAsset = assetForScene.baseAsset as QuestionAsset;
            questionAsset.responses.forEach((r, index) => {
              let imageAssetForScene = this.addQuestionResponseMediaAsset(r, 'Image', 0);
              let videoAssetForScene = this.addQuestionResponseMediaAsset(r, 'Video', 1);
              let audioAssetForScene = this.addQuestionResponseMediaAsset(r, 'Audio', 2);
              r.assets = [];
              r.imageSceneAssetRelationId = imageAssetForScene.sceneAssetRelation.sceneAssetRelationId;
              r.videoSceneAssetRelationId = videoAssetForScene.sceneAssetRelation.sceneAssetRelationId;
              r.audioSceneAssetRelationId = audioAssetForScene.sceneAssetRelation.sceneAssetRelationId;
              r.assets.push(imageAssetForScene);
              r.assets.push(videoAssetForScene);
              r.assets.push(audioAssetForScene);
            });

          } else if (result.data.assetType == 'QuestionSet') {

            if (result.data.assetsInAsset) {
              result.data.assetsInAsset.forEach((assetInAsset, index) => {
                let assetForAsset: AssetInScene = this.addSceneAssetRelation(assetInAsset);
                let questionAsset = assetForAsset.baseAsset as QuestionAsset;
                assetForAsset.baseAsset.name = assetForAsset.baseAsset.name.substr(0, 40);
                assetForAsset.assets = [];
                assetForAsset.questionRules = [];
                assetForAsset.outcomeActions = [];

                assetForScene.assets.push(assetForAsset);

                questionAsset.responses.forEach((r, index) => {
                  let imageAssetForScene = this.addQuestionResponseMediaAsset(r, 'Image', 0);
                  let videoAssetForScene = this.addQuestionResponseMediaAsset(r, 'Video', 1);
                  let audioAssetForScene = this.addQuestionResponseMediaAsset(r, 'Audio', 2);
                  r.assets = [];
                  r.imageSceneAssetRelationId = imageAssetForScene.sceneAssetRelation.sceneAssetRelationId;
                  r.videoSceneAssetRelationId = videoAssetForScene.sceneAssetRelation.sceneAssetRelationId;
                  r.audioSceneAssetRelationId = audioAssetForScene.sceneAssetRelation.sceneAssetRelationId;
                  r.assets.push(imageAssetForScene);
                  r.assets.push(videoAssetForScene);
                  r.assets.push(audioAssetForScene);
                });
              });
            }

          }
        }
      }
    });
    return await popover.present();
  }

  async addQuestionSetToServices(data: any){
    this.messagesService.presentLoadingWindow("Saving Quiz", "saving-quiz");

    let assetForScene = new AssetInScene();
    assetForScene.baseAsset = data.asset.baseAsset;
    assetForScene.sceneAssetRelation = data.asset.sceneAssetRelation;
    assetForScene.events = data.asset.events;
    assetForScene.questionRules = [];
    assetForScene.assets = [];
    assetForScene.expanded = true;
    assetForScene.toBeRemoved = false;

    if (assetForScene.sceneAssetRelation.textToSpeechUrl && assetForScene.sceneAssetRelation.textToSpeechUrl !== "") {
      this.textToSpeechService.setQuestionSetTextToSpeechUrl(assetForScene);
    }
    this.addAssetToServices(assetForScene);

    for(let i: number = 0; i < data.asset.assets.length; i++){
      let assetInAsset = data.asset.assets[i];
            
      let assetForAsset: AssetInScene = this.addSceneAssetRelation(assetInAsset.baseAsset);
      let questionAsset = assetForAsset.baseAsset as QuestionAsset;
      assetForAsset.assets = [];
      assetForAsset.questionRules = assetInAsset.events;
      assetForAsset.questionRules = assetInAsset.questionRules;
      assetForAsset.outcomeActions = [];

      questionAsset.fontFamily = data.questionProperties.questionTextFontFamily;
      questionAsset.textSize = data.questionProperties.questionTextSize;
      questionAsset.textColour = data.questionProperties.questionTextColour;

      assetForScene.assets.push(assetForAsset);

      assetForAsset.events.forEach((event) => {
        event.sceneAssetRelationId = assetForAsset.sceneAssetRelation.sceneAssetRelationId;
      });

      assetForAsset.questionRules.forEach((rule) => {
        rule.sceneAssetRelationId = assetForAsset.sceneAssetRelation.sceneAssetRelationId;
      });

      if (data.questionProperties.textToSpeechEnabled == true) {
        this.textToSpeechService.setQuestionAssetTextToSpeech(assetForAsset);
      }

      for(let j: number = 0; j < questionAsset.responses.length; j++){
        let r: any = questionAsset.responses[j];

        let imageAssetForScene = this.addQuestionResponseMediaAsset(r, 'Image', 0);
        let videoAssetForScene = this.addQuestionResponseMediaAsset(r, 'Video', 1);
        let audioAssetForScene = this.addQuestionResponseMediaAsset(r, 'Audio', 2);
        let imageTypeId = this.assetTypeService.getId('Image');
        let videoTypeId = this.assetTypeService.getId('Video');
        let audioTypeId = this.assetTypeService.getId('Audio');
        let responseImageObject = r.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === imageTypeId);
        let responseVideoObject = r.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === videoTypeId);
        let responseAudioObject = r.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === audioTypeId);

        r.fontFamily = data.questionProperties.questionResponsesTextFontFamily;
        r.textSize = data.questionProperties.questionResponsesTextSize;
        r.textColour = data.questionProperties.questionResponsesTextColour;
        r.imageSceneAssetRelationId = imageAssetForScene.sceneAssetRelation.sceneAssetRelationId;
        r.videoSceneAssetRelationId = videoAssetForScene.sceneAssetRelation.sceneAssetRelationId;
        r.audioSceneAssetRelationId = audioAssetForScene.sceneAssetRelation.sceneAssetRelationId;

        imageAssetForScene.sceneAssetRelation.xPos = responseImageObject.sceneAssetRelation.xPos;
        imageAssetForScene.sceneAssetRelation.yPos = responseImageObject.sceneAssetRelation.yPos;
        imageAssetForScene.sceneAssetRelation.position = responseImageObject.sceneAssetRelation.position;
        imageAssetForScene.sceneAssetRelation.xScale = responseImageObject.sceneAssetRelation.xScale;
        imageAssetForScene.sceneAssetRelation.yScale = responseImageObject.sceneAssetRelation.yScale;
        imageAssetForScene.sceneAssetRelation.scale = responseImageObject.sceneAssetRelation.scale;

        videoAssetForScene.sceneAssetRelation.xPos = responseVideoObject.sceneAssetRelation.xPos;
        videoAssetForScene.sceneAssetRelation.yPos = responseVideoObject.sceneAssetRelation.yPos;
        videoAssetForScene.sceneAssetRelation.position = responseVideoObject.sceneAssetRelation.position;
        videoAssetForScene.sceneAssetRelation.xScale = responseVideoObject.sceneAssetRelation.xScale;
        videoAssetForScene.sceneAssetRelation.yScale = responseVideoObject.sceneAssetRelation.yScale;
        videoAssetForScene.sceneAssetRelation.scale = responseVideoObject.sceneAssetRelation.scale;

        audioAssetForScene.sceneAssetRelation.xPos = responseAudioObject.sceneAssetRelation.xPos;
        audioAssetForScene.sceneAssetRelation.yPos = responseAudioObject.sceneAssetRelation.yPos;
        audioAssetForScene.sceneAssetRelation.position = responseAudioObject.sceneAssetRelation.position;
        audioAssetForScene.sceneAssetRelation.xScale = responseAudioObject.sceneAssetRelation.xScale;
        audioAssetForScene.sceneAssetRelation.yScale = responseAudioObject.sceneAssetRelation.yScale;
        audioAssetForScene.sceneAssetRelation.scale = responseAudioObject.sceneAssetRelation.scale;

        responseImageObject.sceneAssetRelation = imageAssetForScene.sceneAssetRelation;
        responseVideoObject.sceneAssetRelation = videoAssetForScene.sceneAssetRelation;
        responseAudioObject.sceneAssetRelation = audioAssetForScene.sceneAssetRelation;

        if(questionAsset.questionType == 'Media'){
          if(r.hasImage == true){
            let imageAsset = responseImageObject.baseAsset as MediaAsset;
            if(r.imageUploaded == true){
              r.imageUploaded = false;
              let imageAssetSrc = await this.uploadFile(data.questionProperties.responseFiles[i][j].imageFiles, false);
              imageAsset.src = imageAssetSrc;
            }else if(r.imageFromMediaManagementPageId > 0){
              let assetOnManagementPage = this.assetManagementService.assets.find(a => a.baseAssetId == r.imageFromMediaManagementPageId);
              responseImageObject.baseAsset = this.deepCopyService.deepCopy(assetOnManagementPage);
            }
          }
  
          if(r.hasVideo == true){
            let videoAsset = responseVideoObject.baseAsset as MediaAsset;
            if(r.videoUploaded == true){
              r.videoUploaded = false;
              let videoAssetSrc = await this.uploadFile(data.questionProperties.responseFiles[i][j].videoFiles, r.videoCompress);
              videoAsset.uploadStatus = 'uploading';
              videoAsset.src = this.fileService.videoAssetUploadingPlaceholder;
              this.fileService.addVideoToCheckUploadStatus('baseAsset', responseVideoObject.sceneAssetRelation.sceneAssetRelationId, videoAsset, videoAssetSrc);
              this.fileService.initialiseVideoUploadStatusCheck();
            }else if(r.videoFromMediaManagementPageId > 0){
              let assetOnManagementPage = this.assetManagementService.assets.find(a => a.baseAssetId == r.videoFromMediaManagementPageId);
              responseVideoObject.baseAsset = this.deepCopyService.deepCopy(assetOnManagementPage);
            }
          }
  
          if(r.hasAudio == true){
            let audioAsset = responseAudioObject.baseAsset as MediaAsset;
            if(r.audioUploaded == true){
              r.audioUploaded = false;
              let audioAssetSrc = await this.uploadFile(data.questionProperties.responseFiles[i][j].audioFiles, false);
              audioAsset.src = audioAssetSrc;
            }else if(r.audioFromMediaManagementPageId > 0){
              let assetOnManagementPage = this.assetManagementService.assets.find(a => a.baseAssetId == r.audioFromMediaManagementPageId);
              responseAudioObject.baseAsset = this.deepCopyService.deepCopy(assetOnManagementPage);
            }
          }

        }else{
          r.hasImage = false;
          r.hasVideo = false;
          r.hasAudio = false;
        }
      }
    }
    var scenesToSend: Scene[] = [this.scenes.find(s => s.sceneId == assetForScene.sceneAssetRelation.sceneId)];
    this.saveService.scenes = scenesToSend;
    await this.saveService.addOrUpdateAsset(assetForScene);
    
    this.messagesService.dismissLoadingWindowById("saving-quiz");
  }

  async addQuestionToServices(data: any){
    this.messagesService.presentLoadingWindow("Saving Single Question", "saving-single-question");
    let assetForScene = new AssetInScene();
    assetForScene.baseAsset = data.asset.baseAsset;
    assetForScene.sceneAssetRelation = data.asset.sceneAssetRelation;
    assetForScene.events = data.asset.events;
    assetForScene.questionRules = data.asset.questionRules;
    assetForScene.assets = [];
    assetForScene.expanded = true;
    assetForScene.toBeRemoved = false;

    if (assetForScene.sceneAssetRelation.textToSpeechUrl && assetForScene.sceneAssetRelation.textToSpeechUrl !== "") {
      this.textToSpeechService.setQuestionAssetTextToSpeech(assetForScene);
    }
    this.addAssetToServices(assetForScene);

    assetForScene.events.forEach((event) => {
      event.sceneAssetRelationId = assetForScene.sceneAssetRelation.sceneAssetRelationId;
    });

    assetForScene.questionRules.forEach((rule) => {
      rule.sceneAssetRelationId = assetForScene.sceneAssetRelation.sceneAssetRelationId;
    });
    
    let questionAsset = assetForScene.baseAsset as QuestionAsset;

    for(let j: number = 0; j < questionAsset.responses.length; j++){
      let r: any = questionAsset.responses[j];

      let imageAssetForScene = this.addQuestionResponseMediaAsset(r, 'Image', 0);
      let videoAssetForScene = this.addQuestionResponseMediaAsset(r, 'Video', 1);
      let audioAssetForScene = this.addQuestionResponseMediaAsset(r, 'Audio', 2);
      let imageTypeId = this.assetTypeService.getId('Image');
      let videoTypeId = this.assetTypeService.getId('Video');
      let audioTypeId = this.assetTypeService.getId('Audio');
      let responseImageObject = r.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === imageTypeId);
      let responseVideoObject = r.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === videoTypeId);
      let responseAudioObject = r.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === audioTypeId);

      r.fontFamily = data.questionProperties.questionResponsesTextFontFamily;
      r.textSize = data.questionProperties.questionResponsesTextSize;
      r.textColour = data.questionProperties.questionResponsesTextColour;
      r.imageSceneAssetRelationId = imageAssetForScene.sceneAssetRelation.sceneAssetRelationId;
      r.videoSceneAssetRelationId = videoAssetForScene.sceneAssetRelation.sceneAssetRelationId;
      r.audioSceneAssetRelationId = audioAssetForScene.sceneAssetRelation.sceneAssetRelationId;

      imageAssetForScene.sceneAssetRelation.xPos = responseImageObject.sceneAssetRelation.xPos;
      imageAssetForScene.sceneAssetRelation.yPos = responseImageObject.sceneAssetRelation.yPos;
      imageAssetForScene.sceneAssetRelation.position = responseImageObject.sceneAssetRelation.position;
      imageAssetForScene.sceneAssetRelation.xScale = responseImageObject.sceneAssetRelation.xScale;
      imageAssetForScene.sceneAssetRelation.yScale = responseImageObject.sceneAssetRelation.yScale;
      imageAssetForScene.sceneAssetRelation.scale = responseImageObject.sceneAssetRelation.scale;

      videoAssetForScene.sceneAssetRelation.xPos = responseVideoObject.sceneAssetRelation.xPos;
      videoAssetForScene.sceneAssetRelation.yPos = responseVideoObject.sceneAssetRelation.yPos;
      videoAssetForScene.sceneAssetRelation.position = responseVideoObject.sceneAssetRelation.position;
      videoAssetForScene.sceneAssetRelation.xScale = responseVideoObject.sceneAssetRelation.xScale;
      videoAssetForScene.sceneAssetRelation.yScale = responseVideoObject.sceneAssetRelation.yScale;
      videoAssetForScene.sceneAssetRelation.scale = responseVideoObject.sceneAssetRelation.scale;

      audioAssetForScene.sceneAssetRelation.xPos = responseAudioObject.sceneAssetRelation.xPos;
      audioAssetForScene.sceneAssetRelation.yPos = responseAudioObject.sceneAssetRelation.yPos;
      audioAssetForScene.sceneAssetRelation.position = responseAudioObject.sceneAssetRelation.position;
      audioAssetForScene.sceneAssetRelation.xScale = responseAudioObject.sceneAssetRelation.xScale;
      audioAssetForScene.sceneAssetRelation.yScale = responseAudioObject.sceneAssetRelation.yScale;
      audioAssetForScene.sceneAssetRelation.scale = responseAudioObject.sceneAssetRelation.scale;

      responseImageObject.sceneAssetRelation = imageAssetForScene.sceneAssetRelation;
      responseVideoObject.sceneAssetRelation = videoAssetForScene.sceneAssetRelation;
      responseAudioObject.sceneAssetRelation = audioAssetForScene.sceneAssetRelation;

      if(questionAsset.questionType == 'Media'){
        if(r.hasImage == true){
          let imageAsset = responseImageObject.baseAsset as MediaAsset;
          if(r.imageUploaded == true){
            r.imageUploaded = false;
            let imageAssetSrc = await this.uploadFile(data.questionProperties.responseFiles[j].imageFiles, false);
            imageAsset.src = imageAssetSrc;
          }else if(r.imageFromMediaManagementPageId > 0){
            let assetOnManagementPage = this.assetManagementService.assets.find(a => a.baseAssetId == r.imageFromMediaManagementPageId);
            responseImageObject.baseAsset = this.deepCopyService.deepCopy(assetOnManagementPage);
          }
        }

        if(r.hasVideo == true){
          let videoAsset = responseVideoObject.baseAsset as MediaAsset;
          if(r.videoUploaded == true){
            r.videoUploaded = false;
            let videoAssetSrc = await this.uploadFile(data.questionProperties.responseFiles[j].videoFiles, r.videoCompress);
            videoAsset.uploadStatus = 'uploading';
            videoAsset.src = this.fileService.videoAssetUploadingPlaceholder;
            this.fileService.addVideoToCheckUploadStatus('baseAsset', responseVideoObject.sceneAssetRelation.sceneAssetRelationId, videoAsset, videoAssetSrc);
            this.fileService.initialiseVideoUploadStatusCheck();
          }else if(r.videoFromMediaManagementPageId > 0){
            let assetOnManagementPage = this.assetManagementService.assets.find(a => a.baseAssetId == r.videoFromMediaManagementPageId);
            responseVideoObject.baseAsset = this.deepCopyService.deepCopy(assetOnManagementPage);
          }
        }

        if(r.hasAudio == true){
          let audioAsset = responseAudioObject.baseAsset as MediaAsset;
          if(r.audioUploaded == true){
            r.audioUploaded = false;
            let audioAssetSrc = await this.uploadFile(data.questionProperties.responseFiles[j].audioFiles, false);
            audioAsset.src = audioAssetSrc;
          }else if(r.audioFromMediaManagementPageId > 0){
            let assetOnManagementPage = this.assetManagementService.assets.find(a => a.baseAssetId == r.audioFromMediaManagementPageId);
            responseAudioObject.baseAsset = this.deepCopyService.deepCopy(assetOnManagementPage);
          }
        }

      }else{
        r.hasImage = false;
        r.hasVideo = false;
        r.hasAudio = false;
      }
    }

    var scenesToSend: Scene[] = [this.scenes.find(s => s.sceneId == assetForScene.sceneAssetRelation.sceneId)];
    this.saveService.scenes = scenesToSend;
    await this.saveService.addOrUpdateAsset(assetForScene);
    this.messagesService.dismissLoadingWindowById("saving-single-question");
  }

  addQuestionResponseMediaAsset(response: QuestionResponse, assetType: string, index: number): AssetInScene {
    let mediaAsset = new MediaAsset();
    mediaAsset.assetTypeId = this.assetTypeService.getId(assetType);
    mediaAsset.name = response.text + ' - ' + assetType;

    let mediaAssetForQuestionResponse: AssetInScene = this.addSceneAssetRelation(mediaAsset);
    mediaAssetForQuestionResponse.sceneAssetRelation.sceneAssetRelationId += index;
    mediaAssetForQuestionResponse.assets = [];
    mediaAssetForQuestionResponse.questionRules = [];
    mediaAssetForQuestionResponse.outcomeActions = [];

    switch (assetType) {
      case 'Image': {
        let imageSceneAssetRelation = mediaAssetForQuestionResponse.sceneAssetRelation as ImageSceneAssetRelation;
        this.setUpAssetScale(imageSceneAssetRelation, '1.5', '0.75', '0.1');
        this.setUpAssetPosition(imageSceneAssetRelation, '0', '0.525', '0.5');
        break;
      }
      case 'Video': {
        let videoSceneAssetRelation = mediaAssetForQuestionResponse.sceneAssetRelation as VideoSceneAssetRelation;
        this.setUpAssetScale(videoSceneAssetRelation, '1.5', '0.75', '0.1');
        this.setUpAssetPosition(videoSceneAssetRelation, '0', '0.525', '0.5');
        break;
      }
      case 'Audio': {
        let audioSceneAssetRelation = mediaAssetForQuestionResponse.sceneAssetRelation as AudioSceneAssetRelation;
        this.setUpAssetScale(audioSceneAssetRelation, '0.5', '0.25', '0.1');
        this.setUpAssetPosition(audioSceneAssetRelation, '0', '0.25', '0.5');
        break;
      }
    }
    return mediaAssetForQuestionResponse;
  }

  addSceneAssetRelation(asset): AssetInScene {
    var assetType = this.assetTypeService.getType(asset.assetTypeId);
    var assetForScene: AssetInScene = new AssetInScene();
    var sceneAssetRelation: SceneAssetRelation = new SceneAssetRelation();
    sceneAssetRelation = this.setUpSceneAssetRelation(sceneAssetRelation, assetType);

    assetForScene.baseAsset = asset;
    assetForScene.sceneAssetRelation = sceneAssetRelation;
    if (assetForScene.events) {
      assetForScene.events.forEach(event => {
        event.vrEventId = 0;
        event.linkedContentId = 0;
      })
    } else {
      assetForScene.events = [];
    }

    assetForScene.expanded = true;
    assetForScene.toBeRemoved = false;
    return assetForScene;
  }

  setUpSceneAssetRelation(sceneAssetRelation: SceneAssetRelation, assetType): SceneAssetRelation {
    sceneAssetRelation.sceneAssetRelationId = this.getMaxSceneAssetRelationId() + 1;
    sceneAssetRelation.sceneId = this.currentScene.sceneId;

    // FOR ASSETS IN BASE ASSET cameraPos IS NULL
    if (this.cameraPos) {
      this.setUpAssetPosition(sceneAssetRelation, this.cameraPos.x, this.cameraPos.y, this.cameraPos.z);
    } else {
      this.setUpAssetPosition(sceneAssetRelation, '0', '0', '0');
    }


    switch (assetType) {
      case 'Text': {
        this.setUpAssetScale(sceneAssetRelation, '2', '2', '0.1');
        return sceneAssetRelation;
      }
      case 'HotSpot': {
        this.setUpAssetScale(sceneAssetRelation, '0.5', '0.5', '0.1');
        return sceneAssetRelation;
      }
      case 'Audio': {
        this.setUpAssetScale(sceneAssetRelation, '0.5', '0.5', '0.1');
        return sceneAssetRelation;
      }
      case 'Model3D': {
        var modelSceneAssetRelation: Model3DSceneAssetRelation = sceneAssetRelation as Model3DSceneAssetRelation;
        this.setUpAssetScale(modelSceneAssetRelation, '1', '1', '1');
        this.setUpModel3DAssetRotation(modelSceneAssetRelation);
        return modelSceneAssetRelation;
      }
      case 'Invisible': {
        var invisibleSceneAssetRelation: InvisibleSceneAssetRelation = sceneAssetRelation as InvisibleSceneAssetRelation;
        this.setUpAssetScale(invisibleSceneAssetRelation, '0.5', '0.5', '0.1');
        this.setUpInvisibleAssetRotation(invisibleSceneAssetRelation);
        return invisibleSceneAssetRelation;
      }
      case 'Question': {
        this.setUpAssetScale(sceneAssetRelation, '1', '1', '0.1');
        return sceneAssetRelation;
      }
      case 'Image': {
        var imageSceneAssetRelation: ImageSceneAssetRelation = sceneAssetRelation as ImageSceneAssetRelation;
        imageSceneAssetRelation.borderSize = 0;
        imageSceneAssetRelation.borderColour = "";
        imageSceneAssetRelation.keepAspectRatio = true;
        this.setUpAssetScale(imageSceneAssetRelation, '2', '1', '0.1');
        return imageSceneAssetRelation;
      }
      case 'Video': {
        var videoSceneAssetRelation: VideoSceneAssetRelation = sceneAssetRelation as VideoSceneAssetRelation;
        videoSceneAssetRelation.borderSize = 0;
        videoSceneAssetRelation.borderColour = "";
        videoSceneAssetRelation.keepAspectRatio = true;
        this.setUpAssetScale(videoSceneAssetRelation, '2', '1', '0.1');
        return videoSceneAssetRelation;
      }
      case 'QuestionSet': {
        this.setUpAssetScale(sceneAssetRelation, '1', '1', '0.1');
        return sceneAssetRelation;
      }
      default: {
        this.setUpAssetScale(sceneAssetRelation, '2', '1', '0.1');
        return sceneAssetRelation;
      }
    }
  }

  setUpAssetScale(sceneAssetRelation, x: string, y: string, z: string) {
    sceneAssetRelation.xScale = x;
    sceneAssetRelation.yScale = y;
    sceneAssetRelation.zScale = z;
    sceneAssetRelation.scale = x + ' ' + y + ' ' + z;
  }

  setUpModel3DAssetRotation(model3DSceneAssetRelation: Model3DSceneAssetRelation) {
    if (!model3DSceneAssetRelation.xRot) model3DSceneAssetRelation.xRot = '0';
    if (!model3DSceneAssetRelation.yRot) model3DSceneAssetRelation.yRot = '0';
    if (!model3DSceneAssetRelation.zRot) model3DSceneAssetRelation.zRot = '0';
    model3DSceneAssetRelation.rotation = model3DSceneAssetRelation.xRot + ' ' + model3DSceneAssetRelation.yRot + ' ' + model3DSceneAssetRelation.zRot;
  }

  setUpInvisibleAssetRotation(invisibleSceneAssetRelation: InvisibleSceneAssetRelation) {
    if (!invisibleSceneAssetRelation.zRot) invisibleSceneAssetRelation.zRot = '0';
    invisibleSceneAssetRelation.rotation = '0 0 ' + invisibleSceneAssetRelation.zRot;
  }

  setUpAssetPosition(sceneAssetRelation, x: string, y: string, z: string) {
    sceneAssetRelation.xPos = x.toString();
    sceneAssetRelation.yPos = y.toString();
    sceneAssetRelation.zPos = z.toString();
    sceneAssetRelation.position = x + ' ' + y + ' ' + z;
  }

  async copyScene(scene: Scene) {
    var sceneName = scene.name;
    var sceneIndex = scene.sceneIndex;
    await this.messagesService.presentLoadingWindow('Copying scene, please wait.');
    scene.name = this.copyService.copyName(sceneName, this.scenes.filter(s => s.active == true), 30);
    scene.sceneIndex = Math.max.apply(Math, this.scenes.map(function (a) { return a.sceneIndex; })) + 1;
    this.copyService.copyScene(scene, this.assetsInScene).then(sceneDTO => {
      this.scenes.push(sceneDTO.scene);
      this.getSceneEvents(sceneDTO.scene);
      let sceneCopy = this.deepCopyService.deepCopy(sceneDTO.scene);
      this.scenesCopy.push(sceneCopy);
      this.getSceneEvents(sceneCopy);
      if (sceneDTO.assetsInScene) {
        sceneDTO.assetsInScene.forEach(asset => {
          this.addAssetToServices(asset, true);
          this.assetsInSceneCopy.push(this.deepCopyService.deepCopy(asset));
        })
      }
      this.messagesService.loadingWindow.dismiss();
      this.messagesService.savedSuccessfully('Copied Scene');
    });
    scene.name = sceneName;
    scene.sceneIndex = sceneIndex;
  }

  copyAssetInScene(assetInScene: AssetInScene): AssetInScene {
    // Creating name properties in assetsInScene to be used on copyService.copyName
    var assetsInSceneModified: any[] = [];
    this.assetsInScene.forEach((assetInScene: any) => {
      assetInScene.name = assetInScene.baseAsset.name;
      assetsInSceneModified.push(assetInScene);
    });

    var assetForScene: AssetInScene = this.copyService.deepCopyAsset(assetInScene, this.currentScene.sceneId, this.assetsInScene);
    assetForScene.baseAsset.name = this.copyService.copyName(assetForScene.baseAsset.name, assetsInSceneModified);
    this.addAssetToServices(assetForScene);
    return assetForScene;
  }

  getMaxSceneAssetRelationId() {
    var max = 0;
    this.assetsInScene.forEach(assetInScene => {
      let assetType = this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId);
      if (assetInScene.sceneAssetRelation.sceneAssetRelationId > max) {
        max = assetInScene.sceneAssetRelation.sceneAssetRelationId;
      }
      if (assetType == 'Question') {
        let questionAsset = assetInScene.baseAsset as QuestionAsset;
        questionAsset.responses.forEach(r => {
          if (!r.assets) return;

          r.assets.forEach(assetInQuestionResponse => {
            if (assetInQuestionResponse.sceneAssetRelation.sceneAssetRelationId > max) {
              max = assetInQuestionResponse.sceneAssetRelation.sceneAssetRelationId;
            }
          });
        });
      }
      assetInScene.assets.forEach(assetInAsset => {
        let assetInAssetType = this.assetTypeService.getType(assetInAsset.baseAsset.assetTypeId);
        if (assetInAsset.sceneAssetRelation.sceneAssetRelationId > max) {
          max = assetInAsset.sceneAssetRelation.sceneAssetRelationId;
        }
        if (assetInAssetType == 'Question') {
          let questionAssetInAsset = assetInAsset.baseAsset as QuestionAsset;
          questionAssetInAsset.responses.forEach(r => {
            if (!r.assets) return;

            r.assets.forEach(assetInQuestionResponse => {
              if (assetInQuestionResponse.sceneAssetRelation.sceneAssetRelationId > max) {
                max = assetInQuestionResponse.sceneAssetRelation.sceneAssetRelationId;
              }
            });
          });
        }
      });
    })
    return max;
  }

  getVrEventModalId(assetType: string): string {
    var componentId = 'add-object-events-modal';

    if (assetType == 'Question' || 'QuestionSet' || assetType == 'Video' || assetType == 'Audio') {
      componentId += '-question';
    }

    return componentId;
  }

  getIsAssetInAsset(sceneAssetRelationId: number): boolean {
    var result: boolean = false;
    var assetsInSceneResult = this.assetsInScene.find((assetInScene) => assetInScene.assets.filter((assetInAsset) => assetInAsset.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId).length >= 1);
    if (assetsInSceneResult) {
      result = true;
    }
    return result;
  }

  getParentAssetInScene(sceneAssetRelationId: number): AssetInScene {
    var result: AssetInScene;
    var assetInSceneResult = this.assetsInScene.find((assetInScene) => assetInScene.assets.filter((assetInAsset) => assetInAsset.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId).length >= 1);
    if (assetInSceneResult) {
      result = assetInSceneResult;
    } else {
      result = this.assetsInScene.find((assetInScene) => assetInScene.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId);
    }
    return result;
  }

  selectAssetInAsset(assetInScene: AssetInScene, index: number) {
    var assetType = this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId);
    switch (assetType) {
      case 'QuestionSet': {
        var questionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
        questionSetAsset.questionIndex = index;
        break;
      }
    }
  }

  selectParentAssetInAsset(assetInScene: AssetInScene, index: number, confirmationPage: boolean) {
    var assetType = this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId);
    switch (assetType) {
      case 'QuestionSet': {
        var questionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
        if (index == 0) {
          questionSetAsset.questionIndex = questionSetAsset.coverPage == true ? -1 : 0;
        } else {
          questionSetAsset.submitted = confirmationPage == true ? false : true;
          questionSetAsset.questionIndex = index;
        }
        if (assetInScene.sceneAssetRelation.textToSpeechUrl != null) {
          this.textToSpeechService.setQuestionSetTextToSpeechUrl(assetInScene);
        }
        break;
      }
    }
  }

  async openAddAssetEventModal(assetInScene: AssetInScene) {

    if (this._isModalOpen === true) return;
    this._isModalOpen = true;

    this.stopAutoSave();

    var assetType = this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId);
    var newAssetsCount: number = this.addedSceneAssetRelationIds.length;

    await this.saveAddedSceneAssetRelations();

    this.clearArray(this.addedSceneAssetRelationIds);
    if (newAssetsCount > 0) {
      this.messagesService.savedSuccessfully('New Media');
    }

    var existingAssets: AssetInScene[] = this.assetsInScene.filter(a => a.sceneAssetRelation.sceneId == this.currentScene.sceneId);
    this.VrEventService.setUpAssetEvent(assetInScene, existingAssets, this.scenes.filter(c => c.active == true), this.currentScene);



    const modal = await this.modalController.create({
      component: AddEventsModalPage,
      id: this.getVrEventModalId(assetType), // id is used to edit modal size: add -question to id if question video  or audio
    });

    modal.onDidDismiss().then(result => {
      assetInScene.events.forEach(event => {
        this.VrEventAPIService.updateVrEvent(event.vrEventId, event).subscribe();
      })

      this.reinitVrEvent(assetInScene.sceneAssetRelation.sceneAssetRelationId);
      this._isModalOpen = false;
      this.startAutosave(90000);
    });

    return await modal.present();
  }

  saveAddedSceneAssetRelations(): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      // AUTO SAVE NEW ASSETS
      for (let i: number = 0; i < this.addedSceneAssetRelationIds.length; i++) {
        let sceneAssetRelationId = this.addedSceneAssetRelationIds[i];
        var assetToSave: AssetInScene = this.assetsInScene.find(a => a.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId);
        if (assetToSave) {
          var scenesToSend: Scene[] = [this.scenes.find(s => s.sceneId == assetToSave.sceneAssetRelation.sceneId)];
          this.saveService.scenes = scenesToSend;
          await this.saveService.addOrUpdateAsset(assetToSave);
        }
      }
      resolve(true);
    });
  }

  async editResponsesProperties(asset: AssetInScene, callback = () => { }) {

    if (this._isModalOpen === true) return;
    this._isModalOpen = true;

    const modal = await this.modalController.create({
      component: EditResponsesPropertiesModalPage,
      id: 'edit-responses-properties-modal',
      componentProps: {
        'asset': asset,
        'currentScene': this.currentScene,
        'scenes': this.scenes,
        'authorService': this
      }
    });

    modal.onDidDismiss().then((data: any) => {
      // VALIDATE RESPONSE BUTTONS SRC      
      let questionAsset = asset.baseAsset as QuestionAsset;
      questionAsset.responses.forEach(response => {
        if (response.hasImage == true) {
          let imageTypeId = this.assetTypeService.getId('Image');
          let responseAsset = response.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId == imageTypeId);
          let mediaAsset = responseAsset.baseAsset as MediaAsset;
          if (!mediaAsset || (mediaAsset && this.validationService.isEmptyOrNull(mediaAsset.src) === true)) {
            response.hasImage = false;
          }
        }
        if (response.hasVideo == true) {
          let videoTypeId = this.assetTypeService.getId('Video');
          let responseAsset = response.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId == videoTypeId);
          let mediaAsset = responseAsset.baseAsset as MediaAsset;
          if (!mediaAsset || (mediaAsset && this.validationService.isEmptyOrNull(mediaAsset.src) === true)) {
            response.hasVideo = false;
          }
        }
        if (response.hasAudio == true) {
          let audioTypeId = this.assetTypeService.getId('Audio');
          let responseAsset = response.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId == audioTypeId);
          let mediaAsset = responseAsset.baseAsset as MediaAsset;
          if (!mediaAsset || (mediaAsset && this.validationService.isEmptyOrNull(mediaAsset.src) === true)) {
            response.hasAudio = false;
          }
        }
      });

      let questionEntity = document.querySelector('#entity-' + asset.sceneAssetRelation.sceneAssetRelationId);
      if (questionEntity) {
        let closeResponseObjectsButton: any = questionEntity.querySelector('[close-response-object]');
        if (closeResponseObjectsButton) closeResponseObjectsButton.click();
      }

      callback();
      this._isModalOpen = false;
    });

    await modal.present();
  }

  async openAddQuestionRuleModal() {

    if (this._isModalOpen === true) return;
    this._isModalOpen = true;

    const modal = await this.modalController.create({
      component: AddQuestionRulesModalPage,
      id: 'add-question-rules-modal',
      componentProps: {
        'assetInScene': this.selectedAsset,
        'existingAssetsInScene': this.assetsInScene.filter(a => a.toBeRemoved == false && a.sceneAssetRelation.sceneId == this.currentScene.sceneId)
      }
    });

    modal.onDidDismiss().then(result => {
      this.reinitQuestionRules(this.selectedAsset.sceneAssetRelation.sceneAssetRelationId);
      this._isModalOpen = false;
    });

    await modal.present();
  }

  reinitVrEvent(sceneAssetRelationId: number) {
    var submitButtons = document.querySelectorAll("[id^='submit-button-" + sceneAssetRelationId + "'");
    // if a submit button exists with the sceneAssetRelationId then you know it's a question asset.    
    if (submitButtons.length > 0) {
      submitButtons.forEach(submitButton => {
        submitButton.removeAttribute('init-event');

        var i = 0;
        while (submitButton.getAttribute('asset-event__' + i) != null) {
          submitButton.removeAttribute('asset-event__' + i);
          i++;
        }

        // reinitialise event to allow events to be updated.
        submitButton.setAttribute('init-event', sceneAssetRelationId.toString());
      });
    } else {
      // getting the entity that has the event listener
      var entity = document.querySelector('#entity-' + sceneAssetRelationId);
      if (entity) {
        // removing the init-event and removing the event component also removes the event listener in vr-scene.component.ts
        entity.removeAttribute('init-event');

        var i = 0;
        while (entity.getAttribute('asset-event__' + i) != null) {
          entity.removeAttribute('asset-event__' + i);
          i++;
        }

        // reinitialise event to allow events to be updated.
        entity.setAttribute('init-event', sceneAssetRelationId);
      }
    }
  }

  reinitQuestionRules(sceneAssetRelationId: number) {
    // "sub-entity-id" attribute is used for assets in assetInScene
    var submitButton = document.querySelector("[id^='submit-button-'][sub-entity-id='" + sceneAssetRelationId.toString() + "']");
    if (!submitButton) {
      submitButton = document.querySelector("[id^='submit-button-'][entity-id='" + sceneAssetRelationId.toString() + "']");
    }
    // if a submit button exists with the sceneAssetRelationId then you know it's a question asset.    
    if (submitButton) {
      submitButton.removeAttribute('init-rule');

      // reinitialise event to allow events to be updated.
      submitButton.setAttribute('init-rule', sceneAssetRelationId.toString());
    }
  }

  reinitQuestionIndexButtons(sceneAssetRelationId: number) {
    var parentAssetInScene = this.getParentAssetInScene(sceneAssetRelationId);
    var entity = document.querySelector('#entity-' + parentAssetInScene.sceneAssetRelation.sceneAssetRelationId);
    var buttons = entity.querySelectorAll(".question-index");

    buttons.forEach((button, index) => {
      button.removeAttribute('init-question-index-action');
      button.setAttribute('init-question-index-action', index.toString());
    });
  }

  reinitQuestionResponsesPositions(sceneAssetRelationId: number) {
    var entity = document.querySelector('#entity-' + sceneAssetRelationId);
    var responseEntities = entity.querySelectorAll("[set-response-position]");

    responseEntities.forEach((button, index) => {
      button.removeAttribute('set-response-position');
      button.setAttribute('set-response-position', index.toString());
    });
  }

  clearSelectedResponses(sceneAssetRelationId: number) {
    var entityPrefix = "preview-";
    var entity: any = document.querySelector('#' + entityPrefix + 'entity-' + sceneAssetRelationId.toString());
    if (!entity) {
      entityPrefix = "";
      entity = document.querySelector('#entity-' + sceneAssetRelationId.toString());
    }
    var assetInScene = this.getAssetWithSceneAssetRelationId(sceneAssetRelationId);
    var questionAsset: QuestionAsset = assetInScene.baseAsset as QuestionAsset;
    var selectedResponses = entity.querySelectorAll('.selected');

    selectedResponses.forEach(selectedResponse => {
      selectedResponse.setAttribute('animation', {
        property: 'scale',
        to: '1 1 0.01',
        easing: 'easeInBack',
        dir: 'alternate',
        dur: '800'
      });
      var defaultColour = selectedResponse.querySelector('.' + entityPrefix + 'inner-circle').getAttribute('default-colour');
      selectedResponse.classList.remove('selected');
      selectedResponse.querySelector('.' + entityPrefix + 'inner-circle').setAttribute('color', defaultColour);
    });

    questionAsset.selectedResponseIndex = null;
    questionAsset.read = null;
    questionAsset.submitted = null;
  }

  setAllQuestionsInQuestionSetAsRead(assetInScene: AssetInScene) {
    assetInScene.assets.forEach(assetInAsset => {
      var question: QuestionAsset = assetInAsset.baseAsset as QuestionAsset;
      if (question.read != true) {
        question.read = true;
      }
    });
  }

  getCorrectAnsweredQuestionsInAssetInScene(assetInScene: AssetInScene): AssetInScene[] {
    var count: number = 0;
    var questionSet: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;

    if (questionSet.submitted == true) {
      return assetInScene.assets.filter((a, index) => {
        var question: QuestionAsset = a.baseAsset as QuestionAsset;
        var correctResponseIndex: number = question.responses.findIndex(r => r.isCorrect == true);
        if (question.selectedResponseIndex == correctResponseIndex) {
          return true;
        } else {
          return false;
        }
      });
    } else {
      return [];
    }
  }

  // ONLY USED ON AUTHOR PAGE
  getQuestionIndexPosition(assetInScene: AssetInScene, questionIndex: number): string {
    var xPosition: number = -0.84;
    var yPosition: number = -1.38;
    var buttonsInLine: number = 0;
    var questionSet: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;

    var line = Math.floor(questionIndex / 8);

    if (questionSet.submitted == true) {
      yPosition = yPosition - 0.22;
    }

    questionIndex = questionIndex - (line * 8);

    yPosition = yPosition - (line * 0.22);
    xPosition = xPosition + (questionIndex * 0.24);

    if (line == 0) {
      buttonsInLine = assetInScene.assets.length <= 8 ? assetInScene.assets.length : 8;
    } else {
      buttonsInLine = assetInScene.assets.length - 8;
    }

    xPosition = xPosition + (0.94 - (buttonsInLine * 0.1175));

    return xPosition.toString() + ' ' + yPosition.toString() + ' 0.01';
  }

  getQuestionIndexColor(assetInScene: AssetInScene, assetIndex: number): string {
    var color: string = '#136094';
    var questionSet: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
    var question: QuestionAsset = assetInScene.assets[assetIndex].baseAsset as QuestionAsset;

    if (questionSet.questionIndex == assetIndex) {
      color = '#3498db';
    } else {
      if (!question.submitted) {
        if (question.read == true && !question.selectedResponseIndex) {
          color = '#808080';
        }
      } else {
        var correctResponseIndex: number = question.responses.findIndex(r => r.isCorrect == true);
        if (question.selectedResponseIndex != correctResponseIndex) {
          color = '#f04141';
        }
      }
    }

    return color;
  }

  isQuestionCorrect(assetInScene: AssetInScene): boolean {
    var isCorrect: boolean = true;
    var question: QuestionAsset = assetInScene.baseAsset as QuestionAsset;
    if (!question.submitted) {
      if (question.read == true && !question.selectedResponseIndex) {
        isCorrect = false;
      }
    } else {
      var correctResponseIndex: number = question.responses.findIndex(r => r.isCorrect == true);
      if (question.selectedResponseIndex != correctResponseIndex) {
        isCorrect = false;
      }
    }

    return isCorrect;
  }

  getQuestionSetConfirmationText(assetInScene: AssetInScene): string {
    var questionSetAsset: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
    var confirmationText: string = questionSetAsset.confirmationPageAnswersCompletedText;
    assetInScene.assets.forEach(assetInAsset => {
      var questionAsset: QuestionAsset = assetInAsset.baseAsset as QuestionAsset;
      if (!questionAsset.selectedResponseIndex) {
        confirmationText = questionSetAsset.confirmationPageAnswersNotCompletedText;
      }
    });

    return confirmationText;
  }

  getQuestionSetScoreText(assetInScene: AssetInScene): string {
    var scoreMessage: string = "";
    var maxTotalScore = assetInScene.assets.reduce((prev, cur) => {
      var question: QuestionAsset = cur.baseAsset as QuestionAsset;
      return prev + question.score
    }, 0);
    var totalScore = this.getCorrectAnsweredQuestionsInAssetInScene(assetInScene).reduce((prev, cur) => {
      var question: QuestionAsset = cur.baseAsset as QuestionAsset;
      return prev + question.score
    }, 0);

    scoreMessage = 'Your Score: ' + totalScore.toString() + ' of ' + maxTotalScore.toString();
    return scoreMessage;
  }

  getQuestionSetPassedFailText(assetInScene: AssetInScene): string {
    var questionSet: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
    var score = this.getCorrectAnsweredQuestionsInAssetInScene(assetInScene).reduce((prev, cur) => {
      var question = cur.baseAsset as QuestionAsset;
      return prev + question.score
    }, 0);
    var text: string = questionSet.resultsPagePassedText;
    if (score < questionSet.minScoreToPass)
      text = questionSet.resultsPageFailedText;

    return text;

  }

  getResponseCircleColour(sceneAssetRelationId: number): string {
    let assetInScene = this.getParentAssetInScene(sceneAssetRelationId);
    let assetType = this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId);
    let backgroundColour = "#000000";
    let colour = "#000000";

    if(assetType == 'QuestionSet'){
      var questionSet: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
      backgroundColour = questionSet.planeColour;
    }else{
      var question: QuestionAsset = assetInScene.baseAsset as QuestionAsset;
      backgroundColour = question.planeColour;
    }

    if(this.isColourTooDark(backgroundColour)){
      colour="#FFFFFF";
    }

    return colour;
  }

  getResponseInnerCircleColour(sceneAssetRelationId: number): string {
    let assetInScene = this.getParentAssetInScene(sceneAssetRelationId);
    let assetType = this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId);
    let backgroundColour = "#000000";
    let colour = "#000000";

    if(assetType == 'QuestionSet'){
      var questionSet: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
      backgroundColour = questionSet.planeColour;
    }else{
      var question: QuestionAsset = assetInScene.baseAsset as QuestionAsset;
      backgroundColour = question.planeColour;
    }

    if(this.isColourTooDark(backgroundColour)){
      colour="#FFFFFF";
    }

    return colour;
  }

  isColourTooDark(colour: string): boolean{
    colour = colour.substring(1);      // strip #
    var rgb = parseInt(colour, 16);   // convert rrggbb/rgb to decimal
    var r = (rgb >> 16) & 0xff;  // extract red
    var g = (rgb >>  8) & 0xff;  // extract green
    var b = (rgb >>  0) & 0xff;  // extract blue

    var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

    if (luma < 40) {
      return true;
    }else{
      return false;
    }
  }

  achieveOutcome(outcomeId: number) {
    console.log("Achieved", outcomeId);
  }

  setVideosToCheckUploadStatus() {
    this.fileService.videosToCheckUploadStatus = [];

    this.assetsInScene.filter(a => a.toBeRemoved == false).forEach(assetInScene => {
      if (this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId) == 'Video') {
        let videoAsset = assetInScene.baseAsset as MediaAsset;
        if (videoAsset.uploadStatus && videoAsset.uploadStatus !== 'complete') {
          this.fileService.addVideoToCheckUploadStatus('baseAsset', assetInScene.sceneAssetRelation.sceneAssetRelationId, videoAsset, videoAsset.src);
          // set the placeholder
          videoAsset.src = this.fileService.videoAssetUploadingPlaceholder;
        }
      }
      else if (this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId) == 'Question') {
        let questionAsset = assetInScene.baseAsset as QuestionAsset;
        questionAsset.responses.forEach(response => {
          response.assets.forEach(assetInResponse => {
            if (this.assetTypeService.getType(assetInResponse.baseAsset.assetTypeId) == 'Video') {
              let videoAsset = assetInResponse.baseAsset as MediaAsset;
              if (videoAsset.uploadStatus && videoAsset.uploadStatus !== 'complete') {
                this.fileService.addVideoToCheckUploadStatus('baseAsset', assetInResponse.sceneAssetRelation.sceneAssetRelationId, videoAsset, videoAsset.src);
                // set the placeholder
                videoAsset.src = this.fileService.videoAssetUploadingPlaceholder;
              }
            }
          });
        });
      }
      else if (this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId) == 'QuestionSet') {
        assetInScene.assets.forEach(assetInAsset => {
          let questionAsset = assetInAsset.baseAsset as QuestionAsset;
          questionAsset.responses.forEach(response => {
            response.assets.forEach(assetInResponse => {
              if (this.assetTypeService.getType(assetInResponse.baseAsset.assetTypeId) == 'Video') {
                let videoAsset = assetInResponse.baseAsset as MediaAsset;
                if (videoAsset.uploadStatus && videoAsset.uploadStatus !== 'complete') {
                  this.fileService.addVideoToCheckUploadStatus('baseAsset', assetInResponse.sceneAssetRelation.sceneAssetRelationId, videoAsset, videoAsset.src);
                  // set the placeholder
                  videoAsset.src = this.fileService.videoAssetUploadingPlaceholder;
                }
              }
            });
          });
        });
      }
    });

    this.scenes.filter(s => s.active == true).forEach(scene => {
      if (scene.sceneBackgroundFileType == 'Video' && scene.uploadStatus !== 'complete') {
        this.fileService.addVideoToCheckUploadStatus('scene', scene.sceneId, scene, scene.sceneBackgroundSrc);
        // set the placeholder
        scene.sceneBackgroundSrc = this.fileService.videoAssetUploadingPlaceholder;
      }
    });
  }

  removeAssetFromVideosToCheckUploadStatus(asset: AssetInScene) {
    let assetType: string = this.assetTypeService.getType(asset.baseAsset.assetTypeId);
    this.fileService.removeFromVideosToCheckUploadStatus('baseAsset', asset.sceneAssetRelation.sceneAssetRelationId);
  }

  moveCameraTo(xRot: number, yRot: number) {

    // xRot & yRot values ranges from 0 to 360
    // camera rotation ranges from 0 to 6.2831 == 0 to 360 in assets rotation
    let preview = document.querySelector('#preview-scene');
    let camera = document.querySelector('[camera]');
    if (preview) {
      camera = preview.querySelector('[camera]');
    }

    let cameraXRot: number = 0;
    let cameraYRot: number = 0;
    if (!camera) return;

    if (!xRot) xRot = 0;
    if (!yRot) yRot = 0;

    cameraXRot = xRot * (1.5708) / 90;
    cameraYRot = yRot * (6.2831) / 360;

    if (cameraXRot > 1.5708) {
      cameraXRot = 1.5708;
    }

    if (cameraXRot < -1.5708) {
      cameraXRot = -1.5708;
    }

    camera.components["look-controls"].pitchObject.rotation.x = cameraXRot;
    camera.components["look-controls"].yawObject.rotation.y = cameraYRot;
  }

  removeDeletedAssetsInScene() {
    let deletedAssets = this.assetsInScene.filter(a => a.removed === true);
    for (let i: number = 0; i < deletedAssets.length; i++) {
      let assetIndex = this.assetsInScene.findIndex(a => a.sceneAssetRelation.sceneAssetRelationId == deletedAssets[i].sceneAssetRelation.sceneAssetRelationId);
      this.assetsInScene.splice(assetIndex, 1);
    }
  }

  goToAccountPageAlert(): Promise<string> {
    return new Promise<string>(async (resolve) => {
      this.router.navigateByUrl('/projects');

      let message: string = `You have used all your file storage credits. You can no longer edit projects and your current work has been saved. Please purchase more credits or contact your administrator.`;

      const alert = await this.alertController.create({
        header: 'File Storage Credits Used',
        message: message,
        cssClass: 'leave-alert',
        backdropDismiss: false,
        buttons: [{
          text: 'OK',
          cssClass: 'leave-button',
          handler: () => {
            resolve('');
          }
        }]
      });

      alert.onDidDismiss().then((eventDetail) => {
        if (eventDetail.role === 'backdrop') {
          resolve('');
        }
      });

      await alert.present();
    });
  }

  uploadFile(files, compressVideo): Promise<string> {
    return this.fileService.fileEventUpload(files, '5a0ffb5a-475d-4307-bf05-237f82a9302d', compressVideo);
  }

  async openAssetWizard(currentAsset: AssetInScene) {
    this.stopAutoSave();
    currentAsset = this.getParentAssetInScene(currentAsset.sceneAssetRelation.sceneAssetRelationId);
    var assetToCompare = this.deepCopyService.deepCopy(currentAsset);
    var type = this.assetTypeService.getType(currentAsset.baseAsset.assetTypeId);
    var modalId = this.getModalId(type);

    await this.saveAddedSceneAssetRelations();

    var modal = await this.modalController.create({
      component: AssetWizardModalPage,
      id: modalId,
      componentProps: {
        "assetInScene": currentAsset,
        "existingAssetsInScene": this.assetsInScene,
        "existingScenes": this.scenes,
        "editing": true
      },
      backdropDismiss: false
    });

    modal.onDidDismiss().then(async (result) => {
      switch(type){
        case 'QuestionSet': {
          if(result.data){
            await this.checkQuestionSetChanges(result.data, currentAsset, assetToCompare);
          }else{
            let assetIndex = this.assetsInScene.findIndex(a => a.sceneAssetRelation.sceneAssetRelationId == currentAsset.sceneAssetRelation.sceneAssetRelationId);
            if(assetIndex){
              this.assetsInScene.splice(assetIndex, 1);
              this.assetsInScene.push(assetToCompare);
              this.orderAssetsByAssetType();
            }
          }
          this.startAutosave(90000);
          break;
        }
        case 'Question': {
          if(result.data){
            await this.checkQuestionChanges(result.data, currentAsset, assetToCompare);
          }else{            
            let assetIndex = this.assetsInScene.findIndex(a => a.sceneAssetRelation.sceneAssetRelationId == currentAsset.sceneAssetRelation.sceneAssetRelationId);
            if(assetIndex){
              this.assetsInScene.splice(assetIndex, 1);
              this.assetsInScene.push(assetToCompare);
              this.orderAssetsByAssetType();
            }
          }
          this.startAutosave(90000);
          break;
        }
      }
    });

    return await modal.present();
  }

  getModalId(assetType) {
    var modalId: string = '';
    switch (assetType) {
      case 'Text': {
        modalId = 'add-text-object-modal';
        break;
      }
      case 'Image':
      case 'Video':
      case 'Audio': {
        modalId = 'add-media-object-modal';
        break;
      }
      case 'Model3D': {
        modalId = 'add-model3D-object-modal';
        break;
      }
      case 'HotSpot': {
        modalId = 'add-hotspot-object-modal';
        break;
      }
      case 'Question': {
        modalId = 'add-question-object-modal';
        break;
      }
      case 'QuestionSet': {
        modalId = 'add-question-set-object-modal';
        break;
      }
      case 'Invisible': {
        modalId = 'add-invisible-object-modal';
        break;
      }
    }
    return modalId;
  }

  async checkQuestionSetChanges(data: any, currentAsset: AssetInScene, assetToCompare: AssetInScene){
    this.messagesService.presentLoadingWindow("Saving Quiz", "saving-quiz");

    if (currentAsset.sceneAssetRelation.textToSpeechUrl && currentAsset.sceneAssetRelation.textToSpeechUrl !== "") {
      this.textToSpeechService.setQuestionSetTextToSpeechUrl(currentAsset);
    }

    //CHECK RESPONSES MEDIA TO UPLOAD
    for(let i: number = 0; i < currentAsset.assets.length; i++){
      let assetInAsset: any = currentAsset.assets[i];
      let questionAsset = assetInAsset.baseAsset as QuestionAsset;

      if(assetInAsset.new == true){
        let assetForAsset: AssetInScene = this.addSceneAssetRelation(questionAsset);
        assetInAsset.sceneAssetRelation = assetForAsset.sceneAssetRelation;
      }

      if (data.questionProperties.textToSpeechEnabled == true) {
        this.textToSpeechService.setQuestionAssetTextToSpeech(assetInAsset);
      }

      questionAsset.fontFamily = data.questionProperties.questionTextFontFamily;
      questionAsset.textSize = data.questionProperties.questionTextSize;
      questionAsset.textColour = data.questionProperties.questionTextColour;

      for(let j: number = 0; j < questionAsset.responses.length; j++){
        let questionResponse: any = questionAsset.responses[j];
        let imageTypeId = this.assetTypeService.getId('Image');
        let videoTypeId = this.assetTypeService.getId('Video');
        let audioTypeId = this.assetTypeService.getId('Audio');
        let responseImageObject = questionResponse.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === imageTypeId);
        let responseVideoObject = questionResponse.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === videoTypeId);
        let responseAudioObject = questionResponse.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === audioTypeId);
        
        questionResponse.fontFamily = data.questionProperties.questionResponsesTextFontFamily;
        questionResponse.textSize = data.questionProperties.questionResponsesTextSize;
        questionResponse.textColour = data.questionProperties.questionResponsesTextColour;
        
        if(questionResponse.new == true){
          let imageAssetForScene = this.addQuestionResponseMediaAsset(questionResponse, 'Image', 0);
          let videoAssetForScene = this.addQuestionResponseMediaAsset(questionResponse, 'Video', 1);
          let audioAssetForScene = this.addQuestionResponseMediaAsset(questionResponse, 'Audio', 2);

          imageAssetForScene.sceneAssetRelation.xPos = String(responseImageObject.sceneAssetRelation.xPos);
          imageAssetForScene.sceneAssetRelation.yPos = String(responseImageObject.sceneAssetRelation.yPos);
          imageAssetForScene.sceneAssetRelation.position = String(responseImageObject.sceneAssetRelation.position);
          imageAssetForScene.sceneAssetRelation.xScale = String(responseImageObject.sceneAssetRelation.xScale);
          imageAssetForScene.sceneAssetRelation.yScale = String(responseImageObject.sceneAssetRelation.yScale);
          imageAssetForScene.sceneAssetRelation.scale = String(responseImageObject.sceneAssetRelation.scale);

          videoAssetForScene.sceneAssetRelation.xPos = String(responseVideoObject.sceneAssetRelation.xPos);
          videoAssetForScene.sceneAssetRelation.yPos = String(responseVideoObject.sceneAssetRelation.yPos);
          videoAssetForScene.sceneAssetRelation.position = String(responseVideoObject.sceneAssetRelation.position);
          videoAssetForScene.sceneAssetRelation.xScale = String(responseVideoObject.sceneAssetRelation.xScale);
          videoAssetForScene.sceneAssetRelation.yScale = String(responseVideoObject.sceneAssetRelation.yScale);
          videoAssetForScene.sceneAssetRelation.scale = String(responseVideoObject.sceneAssetRelation.scale);

          audioAssetForScene.sceneAssetRelation.xPos = String(responseAudioObject.sceneAssetRelation.xPos);
          audioAssetForScene.sceneAssetRelation.yPos = String(responseAudioObject.sceneAssetRelation.yPos);
          audioAssetForScene.sceneAssetRelation.position = String(responseAudioObject.sceneAssetRelation.position);
          audioAssetForScene.sceneAssetRelation.xScale = String(responseAudioObject.sceneAssetRelation.xScale);
          audioAssetForScene.sceneAssetRelation.yScale = String(responseAudioObject.sceneAssetRelation.yScale);
          audioAssetForScene.sceneAssetRelation.scale = String(responseAudioObject.sceneAssetRelation.scale);
  
          responseImageObject.sceneAssetRelation = imageAssetForScene.sceneAssetRelation;
          responseVideoObject.sceneAssetRelation = videoAssetForScene.sceneAssetRelation;
          responseAudioObject.sceneAssetRelation = audioAssetForScene.sceneAssetRelation;

        }

        if(questionAsset.questionType == 'Media'){
          if(questionResponse.hasImage == true){
            let imageTypeId = this.assetTypeService.getId('Image');
            let imageAsset = responseImageObject.baseAsset as MediaAsset;

            if(questionResponse.imageUploaded == true){
              questionResponse.imageUploaded = false;
              let imageAssetSrc = await this.uploadFile(data.questionProperties.responseFiles[i][j].imageFiles, false);
              imageAsset.src = imageAssetSrc;
            
              let responseImageSrc = document.querySelector('[response-image-src][entity-id="'+responseImageObject.sceneAssetRelation.sceneAssetRelationId+'"]');
              if(responseImageSrc)
                responseImageSrc.setAttribute('src', imageAsset.src);
            }else if(questionResponse.imageFromMediaManagementPageId > 0){
              let assetOnManagementPage = this.assetManagementService.assets.find(a => a.baseAssetId == questionResponse.imageFromMediaManagementPageId);
              responseImageObject.baseAsset = this.deepCopyService.deepCopy(assetOnManagementPage);

              let responseImageSrc = document.querySelector('[response-image-src][entity-id="'+responseImageObject.sceneAssetRelation.sceneAssetRelationId+'"]');
              if(responseImageSrc)
                responseImageSrc.setAttribute('src', responseImageObject.baseAsset.src);
            }
          }
  
          if(questionResponse.hasVideo == true){
            let videoTypeId = this.assetTypeService.getId('Video');
            let videoAsset = responseVideoObject.baseAsset as MediaAsset;

            if(questionResponse.videoUploaded == true){
              questionResponse.videoUploaded = false;
              let videoAssetSrc = await this.uploadFile(data.questionProperties.responseFiles[i][j].videoFiles, true);
              videoAsset.uploadStatus = 'uploading';
              videoAsset.src = this.fileService.videoAssetUploadingPlaceholder;
              this.fileService.addVideoToCheckUploadStatus('baseAsset', responseVideoObject.sceneAssetRelation.sceneAssetRelationId, videoAsset, videoAssetSrc);
              this.fileService.initialiseVideoUploadStatusCheck();

              let responseVideoSrc = document.querySelector('[response-video-src][entity-id="'+responseVideoObject.sceneAssetRelation.sceneAssetRelationId+'"]');
              if(responseVideoSrc)
                responseVideoSrc.setAttribute('src', videoAsset.src);
            }else if(questionResponse.videoFromMediaManagementPageId > 0){
              let assetOnManagementPage = this.assetManagementService.assets.find(a => a.baseAssetId == questionResponse.videoFromMediaManagementPageId);
              responseVideoObject.baseAsset = this.deepCopyService.deepCopy(assetOnManagementPage);

              let responseVideoSrc = document.querySelector('[response-video-src][entity-id="'+responseVideoObject.sceneAssetRelation.sceneAssetRelationId+'"]');
              if(responseVideoSrc)
                responseVideoSrc.setAttribute('src', responseVideoObject.baseAsset.src);
            }
          }
  
          if(questionResponse.hasAudio == true){
            let audioTypeId = this.assetTypeService.getId('Audio');
            let audioAsset = responseAudioObject.baseAsset as MediaAsset;

            if(questionResponse.audioUploaded == true){
              questionResponse.audioUploaded = false;
              let audioAssetSrc = await this.uploadFile(data.questionProperties.responseFiles[i][j].audioFiles, false);
              audioAsset.src = audioAssetSrc;

              let responseAudioSrc = document.querySelector('[response-audio-src][entity-id="'+responseAudioObject.sceneAssetRelation.sceneAssetRelationId+'"]');
              if(responseAudioSrc)
                responseAudioSrc.setAttribute('src', audioAsset.src);
            }else if(questionResponse.audioFromMediaManagementPageId > 0){
              let assetOnManagementPage = this.assetManagementService.assets.find(a => a.baseAssetId == questionResponse.audioFromMediaManagementPageId);
              responseAudioObject.baseAsset = this.deepCopyService.deepCopy(assetOnManagementPage);

              let responseAudioSrc = document.querySelector('[response-audio-src][entity-id="'+responseAudioObject.sceneAssetRelation.sceneAssetRelationId+'"]');
              if(responseAudioSrc)
                responseAudioSrc.setAttribute('src', responseAudioObject.baseAsset.src);
            }
          }
        }else{
          questionResponse.hasImage = false;
          questionResponse.hasVideo = false;
          questionResponse.hasAudio = false;               
        }

      }
    }

    var scenesToSend: Scene[] = [this.scenes.find(s => s.sceneId == currentAsset.sceneAssetRelation.sceneId)];
    this.saveService.scenes = scenesToSend;

    for(let i: number = 0; i < assetToCompare.assets.length; i++){
      let assetInAsset = assetToCompare.assets[i];
      let assetToFind = currentAsset.assets.find(a => a.sceneAssetRelation.sceneAssetRelationId == assetInAsset.sceneAssetRelation.sceneAssetRelationId && a.baseAsset.baseAssetId == assetInAsset.baseAsset.baseAssetId);

      if(!assetToFind){
        assetInAsset.toBeRemoved = true;
        currentAsset.assets.push(assetInAsset);
      }
    }
    await this.saveService.deleteAssets(this.saveService.getAssetsToBeRemoved([currentAsset]));
    await this.saveService.addOrUpdateAsset(currentAsset);
    for (let j: number = 0; j < currentAsset.assets.length; j++) {
      var assetInAsset = currentAsset.assets[j];
      if(!assetInAsset.toBeRemoved){
        await this.saveService.addOrUpdateAsset(assetInAsset);
        this.saveService.addOrUpdateAssetInBaseAsset(assetInAsset.baseAsset, currentAsset.baseAsset, j);
      }
    }
    let assetInAssetToRemove = currentAsset.assets.find(a => a.toBeRemoved == true);
    while(assetInAssetToRemove){
      let assetInAssetToRemoveIndex = currentAsset.assets.findIndex(a => a.sceneAssetRelation.sceneAssetRelationId == assetInAssetToRemove.sceneAssetRelation.sceneAssetRelationId);
      currentAsset.assets.splice(assetInAssetToRemoveIndex, 1);

      assetInAssetToRemove = currentAsset.assets.find(a => a.toBeRemoved == true);
    }
    this.removeDeletedAssetsInScene();

    //CHECK QUESTIONS, EVENTS AND RULES TO DELETE
    for(let i: number = 0; i < assetToCompare.events.length; i++){
      let assetEvent = assetToCompare.events[i];
      let eventToFind = currentAsset.events.find(e => e.vrEventId == assetEvent.vrEventId);

      if(!eventToFind && assetEvent.vrEventId > 0){
        this.VrEventService.removeEvent(assetEvent, assetToCompare);
      }
    }

    for(let i: number = 0; i < assetToCompare.assets.length; i++){
      let assetInAsset = assetToCompare.assets[i];
      let assetToFind = currentAsset.assets.find(a => a.sceneAssetRelation.sceneAssetRelationId == assetInAsset.sceneAssetRelation.sceneAssetRelationId && a.baseAsset.baseAssetId == assetInAsset.baseAsset.baseAssetId);

      if(assetToFind){
        for(let j: number = 0; j < assetInAsset.events.length; j++){
          let assetEvent = assetInAsset.events[j];
          let eventToFind = assetToFind.events.find(e => e.vrEventId == assetEvent.vrEventId);
  
          if(!eventToFind && assetEvent.vrEventId > 0){
            this.VrEventService.removeEvent(assetEvent, assetInAsset);
          }
        }
  
        for(let j: number = 0; j < assetInAsset.questionRules.length; j++){
          let questionRule = assetInAsset.questionRules[j];
          let questionRuleToFind = assetToFind.questionRules.find(qr => qr.questionRuleId == questionRule.questionRuleId);
  
          if(!questionRuleToFind && questionRule.questionRuleId > 0){
            this.questionRuleAPIService.deleteQuestionRule(questionRule.questionRuleId).subscribe();
          }
        }
      }
    }

    //Reset icons and response circle colours
    let entity = document.querySelector('#entity-' + currentAsset.sceneAssetRelation.sceneAssetRelationId);
    let responseCircles = entity.querySelectorAll('[set-response-circle-colour]');
    let responseInnerCircles = entity.querySelectorAll('[set-response-inner-circle-colour]');
    let responseImages = entity.querySelectorAll('[append-response-image-src]');
    let responseVideos = entity.querySelectorAll('[append-response-video-src]');
    let responseAudios = entity.querySelectorAll('[append-response-audio-src]');

    responseCircles.forEach(circle => {
      circle.removeAttribute('set-response-circle-colour');
      circle.setAttribute('set-response-circle-colour', '');
    });

    responseInnerCircles.forEach(circle => {
      circle.removeAttribute('set-response-inner-circle-colour');
      circle.setAttribute('set-response-inner-circle-colour', '');
    });

    responseImages.forEach(image => {
      image.removeAttribute('append-response-image-src');
      setTimeout(() => { image.setAttribute('append-response-image-src', '') }, 500);
    });

    responseVideos.forEach(video => {
      video.removeAttribute('append-response-video-src');
      setTimeout(() => { video.setAttribute('append-response-video-src', '') }, 500);
    });

    responseAudios.forEach(audio => {
      audio.removeAttribute('append-response-audio-src');
      setTimeout(() => { audio.setAttribute('append-response-audio-src', '') }, 500);
    });
    
    this.messagesService.dismissLoadingWindowById("saving-quiz");
  }

  async checkQuestionChanges(data: any, currentAsset: AssetInScene, assetToCompare: AssetInScene){
    this.messagesService.presentLoadingWindow("Saving Single Question", "saving-single-question");
    this.deselectQuestion(currentAsset);
    //CHECK RESPONSES MEDIA TO UPLOAD    
    let questionAsset = currentAsset.baseAsset as QuestionAsset;

    if (currentAsset.sceneAssetRelation.textToSpeechUrl && currentAsset.sceneAssetRelation.textToSpeechUrl !== "") {
      this.textToSpeechService.setQuestionAssetTextToSpeech(currentAsset);
    }

    for(let j: number = 0; j < questionAsset.responses.length; j++){
      let questionResponse: any = questionAsset.responses[j];    
      let imageTypeId = this.assetTypeService.getId('Image');
      let videoTypeId = this.assetTypeService.getId('Video');
      let audioTypeId = this.assetTypeService.getId('Audio');
      let responseImageObject = questionResponse.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === imageTypeId);
      let responseVideoObject = questionResponse.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === videoTypeId);
      let responseAudioObject = questionResponse.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === audioTypeId);   

      questionResponse.fontFamily = data.questionProperties.questionResponsesTextFontFamily;
      questionResponse.textSize = data.questionProperties.questionResponsesTextSize;
      questionResponse.textColour = data.questionProperties.questionResponsesTextColour;
        
      if(questionResponse.new == true){
        let imageAssetForScene = this.addQuestionResponseMediaAsset(questionResponse, 'Image', 0);
        let videoAssetForScene = this.addQuestionResponseMediaAsset(questionResponse, 'Video', 1);
        let audioAssetForScene = this.addQuestionResponseMediaAsset(questionResponse, 'Audio', 2);

        imageAssetForScene.sceneAssetRelation.xPos = String(responseImageObject.sceneAssetRelation.xPos);
        imageAssetForScene.sceneAssetRelation.yPos = String(responseImageObject.sceneAssetRelation.yPos);
        imageAssetForScene.sceneAssetRelation.position = String(responseImageObject.sceneAssetRelation.position);
        imageAssetForScene.sceneAssetRelation.xScale = String(responseImageObject.sceneAssetRelation.xScale);
        imageAssetForScene.sceneAssetRelation.yScale = String(responseImageObject.sceneAssetRelation.yScale);
        imageAssetForScene.sceneAssetRelation.scale = String(responseImageObject.sceneAssetRelation.scale);

        videoAssetForScene.sceneAssetRelation.xPos = String(responseVideoObject.sceneAssetRelation.xPos);
        videoAssetForScene.sceneAssetRelation.yPos = String(responseVideoObject.sceneAssetRelation.yPos);
        videoAssetForScene.sceneAssetRelation.position = String(responseVideoObject.sceneAssetRelation.position);
        videoAssetForScene.sceneAssetRelation.xScale = String(responseVideoObject.sceneAssetRelation.xScale);
        videoAssetForScene.sceneAssetRelation.yScale = String(responseVideoObject.sceneAssetRelation.yScale);
        videoAssetForScene.sceneAssetRelation.scale = String(responseVideoObject.sceneAssetRelation.scale);

        audioAssetForScene.sceneAssetRelation.xPos = String(responseAudioObject.sceneAssetRelation.xPos);
        audioAssetForScene.sceneAssetRelation.yPos = String(responseAudioObject.sceneAssetRelation.yPos);
        audioAssetForScene.sceneAssetRelation.position = String(responseAudioObject.sceneAssetRelation.position);
        audioAssetForScene.sceneAssetRelation.xScale = String(responseAudioObject.sceneAssetRelation.xScale);
        audioAssetForScene.sceneAssetRelation.yScale = String(responseAudioObject.sceneAssetRelation.yScale);
        audioAssetForScene.sceneAssetRelation.scale = String(responseAudioObject.sceneAssetRelation.scale);

        responseImageObject.sceneAssetRelation = imageAssetForScene.sceneAssetRelation;
        responseVideoObject.sceneAssetRelation = videoAssetForScene.sceneAssetRelation;
        responseAudioObject.sceneAssetRelation = audioAssetForScene.sceneAssetRelation;
      }

      if(questionAsset.questionType == 'Media'){
        if(questionResponse.hasImage == true){
          let imageAsset = responseImageObject.baseAsset as MediaAsset;
          if(questionResponse.imageUploaded == true){
            questionResponse.imageUploaded = false;
            let imageAssetSrc = await this.uploadFile(data.questionProperties.responseFiles[j].imageFiles, false);
            imageAsset.src = imageAssetSrc;
            
            let responseImageSrc = document.querySelector('[response-image-src][entity-id="'+responseImageObject.sceneAssetRelation.sceneAssetRelationId+'"]');
            if(responseImageSrc){
              responseImageSrc.setAttribute('src', imageAsset.src);
            }

          }else if(questionResponse.imageFromMediaManagementPageId > 0){
            let assetOnManagementPage = this.assetManagementService.assets.find(a => a.baseAssetId == questionResponse.imageFromMediaManagementPageId);
            responseImageObject.baseAsset = this.deepCopyService.deepCopy(assetOnManagementPage);

            let responseImageSrc = document.querySelector('[response-image-src][entity-id="'+responseImageObject.sceneAssetRelation.sceneAssetRelationId+'"]');
            if(responseImageSrc)
              responseImageSrc.setAttribute('src', responseImageObject.baseAsset.src);
          }
        }
  
        if(questionResponse.hasVideo == true){
          let videoAsset = responseVideoObject.baseAsset as MediaAsset;

          if(questionResponse.videoUploaded == true){
            questionResponse.videoUploaded = false;
            let videoAssetSrc = await this.uploadFile(data.questionProperties.responseFiles[j].videoFiles, true);
            videoAsset.uploadStatus = 'uploading';
            videoAsset.src = this.fileService.videoAssetUploadingPlaceholder;
            this.fileService.addVideoToCheckUploadStatus('baseAsset', responseVideoObject.sceneAssetRelation.sceneAssetRelationId, videoAsset, videoAssetSrc);
            this.fileService.initialiseVideoUploadStatusCheck();

            let responseVideoSrc = document.querySelector('[response-video-src][entity-id="'+responseVideoObject.sceneAssetRelation.sceneAssetRelationId+'"]');
            if(responseVideoSrc)
              responseVideoSrc.setAttribute('src', videoAsset.src);
          }else if(questionResponse.videoFromMediaManagementPageId > 0){
            let assetOnManagementPage = this.assetManagementService.assets.find(a => a.baseAssetId == questionResponse.videoFromMediaManagementPageId);
            responseVideoObject.baseAsset = this.deepCopyService.deepCopy(assetOnManagementPage);

            let responseVideoSrc = document.querySelector('[response-video-src][entity-id="'+responseVideoObject.sceneAssetRelation.sceneAssetRelationId+'"]');
            if(responseVideoSrc)
              responseVideoSrc.setAttribute('src', responseVideoObject.baseAsset.src);
          }
        }
  
        if(questionResponse.hasAudio == true){
          let audioAsset = responseAudioObject.baseAsset as MediaAsset;

          if(questionResponse.audioUploaded == true){
            questionResponse.audioUploaded = false;
            let audioAssetSrc = await this.uploadFile(data.questionProperties.responseFiles[j].audioFiles, false);
            audioAsset.src = audioAssetSrc;

            let responseAudioSrc = document.querySelector('[response-audio-src][entity-id="'+responseAudioObject.sceneAssetRelation.sceneAssetRelationId+'"]');
            if(responseAudioSrc)
              responseAudioSrc.setAttribute('src', audioAsset.src);
          }else if(questionResponse.audioFromMediaManagementPageId > 0){
            let assetOnManagementPage = this.assetManagementService.assets.find(a => a.baseAssetId == questionResponse.audioFromMediaManagementPageId);
            responseAudioObject.baseAsset = this.deepCopyService.deepCopy(assetOnManagementPage);

            let responseAudioSrc = document.querySelector('[response-audio-src][entity-id="'+responseAudioObject.sceneAssetRelation.sceneAssetRelationId+'"]');
            if(responseAudioSrc)
              responseAudioSrc.setAttribute('src', responseAudioObject.baseAsset.src);
          }
        }
      }else{
        questionResponse.hasImage = false;
        questionResponse.hasVideo = false;
        questionResponse.hasAudio = false;               
      }
    }

    var scenesToSend: Scene[] = [this.scenes.find(s => s.sceneId == currentAsset.sceneAssetRelation.sceneId)];
    this.saveService.scenes = scenesToSend;
    await this.saveService.addOrUpdateAsset(currentAsset);

    //CHECK QUESTIONS, EVENTS AND RULES TO DELETE
    for(let i: number = 0; i < assetToCompare.events.length; i++){
      let assetEvent = assetToCompare.events[i];
      let eventToFind = currentAsset.events.find(e => e.vrEventId == assetEvent.vrEventId);

      if(!eventToFind && assetEvent.vrEventId > 0){
        this.VrEventService.removeEvent(assetEvent, assetToCompare);
      }
    }
    for(let i: number = 0; i < assetToCompare.questionRules.length; i++){
      let questionRule = assetToCompare.questionRules[i];
      let questionRuleToFind = currentAsset.questionRules.find(qr => qr.questionRuleId == questionRule.questionRuleId);

      if(!questionRuleToFind && questionRule.questionRuleId > 0){
        this.questionRuleAPIService.deleteQuestionRule(questionRule.questionRuleId).subscribe();
      }
    }

    //Reset icons and response circle colours
    let entity = document.querySelector('#entity-' + currentAsset.sceneAssetRelation.sceneAssetRelationId);
    let responseCircles = entity.querySelectorAll('[set-response-circle-colour]');
    let responseInnerCircles = entity.querySelectorAll('[set-response-inner-circle-colour]');
    let responseImages = entity.querySelectorAll('[append-response-image-src]');
    let responseVideos = entity.querySelectorAll('[append-response-video-src]');
    let responseAudios = entity.querySelectorAll('[append-response-audio-src]');

    responseCircles.forEach(circle => {
      circle.removeAttribute('set-response-circle-colour');
      circle.setAttribute('set-response-circle-colour', '');
    });

    responseInnerCircles.forEach(circle => {
      circle.removeAttribute('set-response-inner-circle-colour');
      circle.setAttribute('set-response-inner-circle-colour', '');
    });

    responseImages.forEach(image => {
      image.removeAttribute('append-response-image-src');
      image.removeAttribute('src');
      setTimeout(() => { image.setAttribute('append-response-image-src', '') }, 500);
    });

    responseVideos.forEach(video => {
      video.removeAttribute('append-response-video-src');
      setTimeout(() => { video.setAttribute('append-response-video-src', '') }, 500);
    });

    responseAudios.forEach(audio => {
      audio.removeAttribute('append-response-audio-src');
      setTimeout(() => { audio.setAttribute('append-response-audio-src', '') }, 500);
    });

    this.messagesService.dismissLoadingWindowById("saving-single-question");
  }

  deselectQuestion(assetInScene: AssetInScene) {
    this.clearSelectedResponses(assetInScene.sceneAssetRelation.sceneAssetRelationId);
  }

  setVrEventAssetToResult(sceneAssetRelationId: number, VrEventInDb): VrEventAssetRelation {

    var VrEventAssetRelation: VrEventAssetRelation = {
      'sceneAssetRelationId': sceneAssetRelationId,
      'vrEventId': VrEventInDb.vrEventId,
      'vrEventAssetRelationId': 0
    };

    return VrEventAssetRelation;
  }

  orderAssetsByAssetType(){
    let invisibleAssets = this.assetsInScene.filter(a => this.assetTypeService.getType(a.baseAsset.assetTypeId) == 'Invisible');

    //Remove the invisible assets so the vr scene can be updated
    let invisibleAsset = this.assetsInScene.find(a => this.assetTypeService.getType(a.baseAsset.assetTypeId) == 'Invisible');
    while(invisibleAsset){
      let invisibleAssetIndex = this.assetsInScene.findIndex(a => a.sceneAssetRelation.sceneAssetRelationId == invisibleAsset.sceneAssetRelation.sceneAssetRelationId);
      this.assetsInScene.splice(invisibleAssetIndex, 1);

      invisibleAsset = this.assetsInScene.find(a => this.assetTypeService.getType(a.baseAsset.assetTypeId) == 'Invisible');
    }

    this.assetsInScene.sort((a, b) => {
      // Use toUpperCase() to ignore character casing
      const assetTypeA = this.getAssetTypeModified(a.baseAsset.assetTypeId);
      const assetTypeB = this.getAssetTypeModified(b.baseAsset.assetTypeId);
    
      let comparison = 0;
      if (assetTypeA > assetTypeB) {
        comparison = 1;
      } else if (assetTypeA < assetTypeB) {
        comparison = -1;
      }
      return comparison;
    });

    setTimeout(() => this.assetsInScene = [...this.assetsInScene, ...invisibleAssets], 500)
  }

  getAssetTypeModified(assetTypeId: number){
    const assetType = this.assetTypeService.getType(assetTypeId);

    switch(assetType){
      case 'Question':{
        return 'Single Question';
      }
      case 'QuestionSet':{
        return 'Quiz';
      }
      case 'Invisible':{
        return 'zInvisible';
      }
      default: {
        return assetType;
      }
    }
  }
}
